import { configureIndicatorColors } from './indicatorColors';
import { configureSettingsModalAccessibility } from './settingsModalAccessibility';
import { configureCandleTooltipPlacement } from './candleTooltipPlacement';
import { optimizeChartFontCheck } from './chartFontCheck';

import { getChartInterval, getChartIntervalMs } from './chartIntervals';

import { configureChartTimeAxis, indicatorNumberFormat, minimumPanelHeight, fitPanelHeights } from './chartAxisPresentation';

import { cacheTimezone } from './cachedTimezone';

import { normalizeHistory, reconcileCandles, selectRecoveryRows, olderCandles, mergeLiveCandle, sameCandle, removeMisalignedCandles } from './candleRecovery';

import { matchesChartSubscription } from '../../../data/websocket/chartSubscription';

import { watchChartRecovery } from './chartRecovery';

import { createLiveTickIdentity } from './liveTickIdentity';

import { createTradeMarkerOwner, groupTradeMarkers } from './tradeMarkers';

import { configureVolumeIndicatorData } from './volumeIndicatorData';
import { configureIndicatorCalculations } from './indicatorCalculations';
import { configureIndicatorLiveValues } from './indicatorLiveValues';
import { configureStockLegendCleanup, configureStockAxisCleanup } from './indicatorCleanup';
import { configureSettingsModalCleanup } from './settingsModalCleanup';

import { hasLayoutMutation } from './layoutMutations';

import { configureTextEditor } from './configureTextEditor';

import { configureDrawingPersistence } from './configureDrawingPersistence';
import { configureDrawingInteraction, configureDrawingActions } from './configureDrawingInteraction';

import { watchChartDensity } from './chartDensity';

import { useTranslation } from 'react-i18next';

import { chartLocale, chartText } from '../../../i18n/chartLocale';

import { useMetricsContext } from '../../../contexts/Metrics-Context';

import { normalizeOffset } from '../../../utils/timezone';

import { useThemeContext } from '../../../contexts/Theme-Context';

import React, { useEffect, useRef, useState } from 'react';

import { createChartLayoutDriver } from '../../../pages/main/chartLayoutDriver';

import Spinner from '../../utils/spinner/Spinner';

import { createDrawingHistory } from './drawingHistory';

import * as am5 from "@amcharts/amcharts5";

import * as am5xy from "@amcharts/amcharts5/xy";

import * as am5stock from "@amcharts/amcharts5/stock";

import am5themes_Dark from '@amcharts/amcharts5/themes/Material';

import am5themes_Responsive from '@amcharts/amcharts5/themes/Responsive';

import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';



import { API_ENDPOINT_KLINES_MT } from '../../../data/Endpoints-API';

import { useSymbolContext } from '../../../contexts/Symbol-Context';

import { useAuthContext } from '../../../contexts/Auth-Context';

import { useChartContext } from '../../../contexts/Chart-Context';

// import '../../../themes/old-dark.scss'

// import '../../../themes/dark.scss'

// import './Chart.scss';

import './Chart-Toolbar.scss';

import './am5stockChart.scss'

import { useAccountManagerContext } from '../../../contexts/Account-Manager-Context';

import { eaChartToolbarReady, eaChartToolbarTeardown } from '../ea/eaApi.js';



// Same icon spacing whether the sidebar list scrolls or not, so hover targets

// stay readable on short charts without the layout jumping when it grows.

const DRAW_SIDEBAR_GAP = 10;



const Chart = ({ mobileMode }) => {

  const { theme } = useThemeContext();

  const { i18n } = useTranslation();

  const language = i18n.resolvedLanguage || i18n.language;

  const { utcOffset } = useMetricsContext();

  const chartColors = theme === 'light'

    ? { bg: '#edf1f6', panel: '#fcfcfd', axisStroke: '#e2e8f0', text: '#202c3c', muted: '#718096' }

    : { bg: '#1a1f36', panel: '#252b42', axisStroke: '#252b42', text: '#e8eaf0', muted: '#b8bcc8' };

  // Context

  const {

    clickedPosition,

    showTooltip,

    setShowTooltip,

    showBullets,

    loadingSymbolContext,

    symbolNames,

    updateSymbolName,

    symbolInfo,

    updateSymbolDetailsData,

    setSelectedCategoryId,

    symbolWithCategories,

    setSelectedSymbolSession,

  } = useSymbolContext();

  const {

    user,

    platFromData,

    chartSubscription,

    selectedAuthSymbol,

    selectedAuthSymbolId,

    setAuthSelectedSymbol,

    setAuthTimeFrame,

    setAuthSelectedCategory,

    defaultSelectedCategory,

    isReconnected,

    setIsReconnected,
    sendDataToServer

  } = useAuthContext();

  const {

    selectedTimeFrame,

    updateChartTimeFrame,

    // selectedSeriesType,

    zoomRange,

    setLineCandle,

    selectedStyle,

    setSelectedStyle,

    styleOptions,

  } = useChartContext();

  const { openPositions, closedPositions , closedPositionsAll} = useAccountManagerContext();

  // Resolve the request as one tuple from this account's loaded symbol list.

  // Persisted IDs can belong to a previous account or a different symbol.

  const requestSymbol = Array.isArray(symbolWithCategories)

    ? symbolWithCategories.find(symbol => symbol.name === selectedAuthSymbol)

    : undefined;

  const requestUserId = Number(user?.userId);

  const requestSymbolId = Number(requestSymbol?.id);

  const requestCategoryId = Number(requestSymbol?.symbol_category);

  const chartRequestReady = !loadingSymbolContext && requestUserId > 0

    && requestSymbolId > 0 && requestCategoryId > 0

    && Boolean(selectedAuthSymbol && selectedTimeFrame);

  const chartRequestKey = JSON.stringify([

    requestUserId, requestSymbolId, requestCategoryId, selectedAuthSymbol, selectedTimeFrame,

  ]);





  const chartRef = useRef(null);

  const mainPanelRef = useRef(null);

  const valueSeriesRef = useRef(null);

  const volumeSeriesRef = useRef(null);

  const cleanupRef = useRef(null);

  let timeFrameChartSetup = 'minute';



  timeFrameChartSetup = (selectedTimeFrame === '1m' || selectedTimeFrame === '5m' || selectedTimeFrame === '15m' || selectedTimeFrame === '30m')

  ? 'minute'

  : (selectedTimeFrame === '1h' || selectedTimeFrame === '4h')

      ? 'hour'

      : (selectedTimeFrame === '1d')

          ? 'day'

          : 'minute'



  const numberFormat = '#,#### ';



  // useEffect(() => {

  //   if (clickedPosition) {

  //     createChartBulletClosePosition(clickedPosition);

  //   }

  // }, [clickedPosition]);







  useEffect(() => {

    if (selectedAuthSymbol !== '') {

      updateSymbolDetailsData(selectedAuthSymbol);

    }

  }, [selectedAuthSymbol]);



  //local states

  let [stockChart2, setStockChart2] = useState(null);

  const currentLabel2Ref = useRef(null);

  const currentLabelNew2Ref = useRef(null);

  const currentValueDataItem2Ref = useRef(null);

  const currentValueDataItemNewRef = useRef(null);



  const [chartInitialized, setChartInitialized] = useState(false);

  const [chartLoading, setChartLoading] = useState(true);






  let [dataReady, setDataReady] = useState(false);

  const liveTickIdentityRef = useRef(createLiveTickIdentity());

  const allChartDataRef = useRef([]);

  const currentChartDataRef = useRef([]);

  const loadedChartRequestKeyRef = useRef(null);

  const pendingChartSeriesRef = useRef(null);

  const tradeMarkersRef = useRef(null);

  if (!tradeMarkersRef.current) tradeMarkersRef.current = createTradeMarkerOwner();

  const markerDataRef = useRef(null);

  markerDataRef.current = { openPositions, closedPositionsAll, selectedAuthSymbol,

    selectedTimeFrame, showBullets, selectedStyle, chartColors };



  let root = null;

  let currentLabel = null;

  let currentLabelNew = null;

  let currentValueDataItem = null;

  let candleLength = 450;



  // useEffect to handle component lifecycle

  useEffect(() => {

    //nothing will load in this component until SymbolContext fully loaded

    if (chartRequestReady) {

        // Clean up previous listeners

        if (cleanupRef.current) {

          cleanupRef.current();

        }

        // Setup chart and store cleanup function

        cleanupRef.current = chartSetup();

    }



    // Cleanup on unmount or dependency change

    return () => {

      if (cleanupRef.current) {

        cleanupRef.current();

        cleanupRef.current = null;

      }

    };

  }, [chartRequestReady, chartRequestKey, showTooltip, showBullets, utcOffset, theme, language, selectedStyle.buyColor, selectedStyle.sellColor]);



  useEffect(() => {

    createChartBullets();

  }, [openPositions, closedPositionsAll, selectedAuthSymbol, selectedTimeFrame, showBullets]);



  useEffect(() => () => tradeMarkersRef.current.dispose(), []);



  // Refresh candles after reconnect without tearing down a working chart or

  // starting a second loading cycle alongside the normal setup effect.

  useEffect(() => {

    const series = valueSeriesRef.current;

    if (!isReconnected || !chartRequestReady || !series || series.isDisposed()) return;

    setIsReconnected(false);

    // The recovery watcher coalesces reconnect and tab-return into one request.

  }, [isReconnected, chartRequestReady, chartRequestKey]);



  useEffect(() => {

    if (!chartRequestReady) return;

    return watchChartRecovery({

      win: window, doc: document,
      acceptsPacket: packet => packet?.type === 'klines' && matchesChartSubscription(packet, chartSubscription),

      recover: () => {

        const series = valueSeriesRef.current;

        if (!series || series.isDisposed()) return false;

        // Other account messages may still arrive while the selected candle
        // subscription is stale. Refresh that subscription as well as history.
        sendDataToServer();

        return loadChartData(series, undefined, false, true);

      },

    });

  }, [chartRequestReady, chartRequestKey]);



  // useEffect(() => {

  //   if (

  //     !loadingSymbolContext &&

  //     chartRef?.current &&

  //     valueSeriesRef?.current &&

  //     chartLoadedFirstTime

  //   ) {

  //     debugger;

  //     loadChartData(valueSeriesRef?.current);

  //   }

  // }, [selectedAuthSymbol, selectedTimeFrame]);



  useEffect(() => {

    if (!dataReady) liveTickIdentityRef.current = createLiveTickIdentity();

    //nothing will load in this component until SymbolContext fully loaded

    if (!loadingSymbolContext && dataReady) {

      updateLiveFeedData();

    }

  }, [platFromData[1], dataReady]);



  //dispose root if there is any because only root could exists

  const maybeDisposeRoot = (divId) => {

    am5.array.each(am5.registry.rootElements, function (root) {

      if (root.dom.id === divId) {

        root.dispose();

      }

    });

  };



  // Main chart setup function

  const chartSetup = () => {

    if (!chartRequestReady) return;

    // Pull the Strategy host out of #chartcontrols before amCharts wipes it

    // (style change, symbol, TF, bullets — same crash as the old MutationObserver).

    eaChartToolbarTeardown();



    //dispose root if there is any because only root could exists

    maybeDisposeRoot('chartdiv');



    //#region CHART SETUP

    root = am5.Root.new('chartdiv');

    root.locale = chartLocale(language);

    optimizeChartFontCheck(root);

    root.timezone = cacheTimezone(am5.Timezone.new(normalizeOffset(utcOffset)));

    // The layout owner updates dimensions before this synchronous canvas resize.

    const layoutRoot = root;

    let layoutAutoResize = layoutRoot.autoResize;

    const pauseLayoutResize = () => {

      layoutAutoResize = layoutRoot.autoResize;

      layoutRoot.autoResize = false;

    };

    const resumeLayoutResize = () => {

      layoutRoot.autoResize = layoutAutoResize;

    };

    const provideLayoutDriver = event => {

      if (layoutRoot.isDisposed()) return;

      event.detail.driver = createChartLayoutDriver(layoutRoot, () => syncTimeAxis());

    };

    window.addEventListener('chart-layout-driver', provideLayoutDriver);

    window.addEventListener('chart-layout-start', pauseLayoutResize);

    window.addEventListener('chart-layout-end', resumeLayoutResize);

    if (document.documentElement.classList.contains('chart-layout-transition')) pauseLayoutResize();

    root.addDisposer(new am5.Disposer(() => {

      window.removeEventListener('chart-layout-driver', provideLayoutDriver);

      window.removeEventListener('chart-layout-start', pauseLayoutResize);

      window.removeEventListener('chart-layout-end', resumeLayoutResize);

    }));



    // Theme/locale/tool settings may rebuild the canvas after initial data has

    // arrived. Reuse that same request's candles instead of fetching them again.

    const hasCurrentData = loadedChartRequestKeyRef.current === chartRequestKey;

    setChartLoading(!hasCurrentData);

    setDataReady(hasCurrentData);



    // The following line removes the AMCharts logo even in the free version. BUT THIS IS AGAINST THEIR LICENSE AGREEMENT.

    root._logo.dispose();



    //custom theme

    const myTheme = am5.Theme.new(root);

    root.addDisposer(new am5.Disposer(watchChartDensity(root, myTheme)));

    myTheme.rule("EditableLabel").setup = configureTextEditor;

    const selectionInk = am5.color(theme === 'light' ? 0x374151 : 0xd5ddeb);
    myTheme.rule('Rectangle', ['selector']).setAll({
      stroke: selectionInk, strokeOpacity: 1, strokeWidth: 1, strokeDasharray: [2, 2],
    });

    myTheme.rule('Circle', ['drawing', 'grip']).setAll({stroke: selectionInk, strokeOpacity: 1, strokeWidth: 1.5});

    const selectionFill = am5.color(theme === 'light' ? 0xfcfcfd : 0x252b42);

    myTheme.rule('RoundedRectangle', ['resizer', 'grip']).setAll({

      fill: selectionFill, stroke: selectionInk, strokeOpacity: 1, strokeWidth: 1.5,

    });

    myTheme.rule('RoundedRectangle', ['resizer', 'grip', 'outline']).setAll({

      fill: selectionInk, fillOpacity: 0, strokeOpacity: 0,

    });

    myTheme.rule('Rectangle', ['resizer', 'rectangle']).setAll({

      stroke: selectionInk, strokeOpacity: 0.85,

    });

    myTheme.rule('StockPanel').set('paddingLeft', 0);



    myTheme.rule('Grid').setAll({

      stroke: am5.color(theme === 'light' ? '#aab7c8' : 0x808080),

      strokeWidth: 1,

    });



    myTheme.rule('Label').setAll({

      fill: am5.color(chartColors.text), // Updated to match theme $boldTextColor

    });



    // Axis text must stay readable independently of the app's compact base font.

    myTheme.rule('AxisLabel').set('fontSize', 10);



    myTheme.rule('Indicator').set('autoOpenSettings', false);

    myTheme.rule('StockLegend').setAll({ stateAnimationDuration: 0, interpolationDuration: 0 });

    myTheme.rule('Container', ['legend', 'itemcontainer']).set('stateAnimationDuration', 0);

    // Keep StockLegend cards solid/sharp for MA + RSI alike (default theme uses shadowBlur:5).

    // Match without requiring "stocklegend" on the background sprite — that tag is not always

    // present on item backgrounds, which left overlay MA cards soft over candles.

    myTheme.rule('RoundedRectangle', ['legend', 'itemcontainer', 'background']).setAll({

      fill: am5.color(chartColors.panel),

      fillOpacity: 1,

      shadowBlur: 0,

      shadowOpacity: 0,

      shadowOffsetX: 0,

      shadowOffsetY: 0,

      stateAnimationDuration: 0,

    });

    myTheme.rule('RoundedRectangle', ['legend', 'itemcontainer', 'background', 'stocklegend']).setAll({

      fill: am5.color(chartColors.panel),

      fillOpacity: 1,

      shadowBlur: 0,

      shadowOpacity: 0,

      shadowOffsetX: 0,

      shadowOffsetY: 0,

    });

    myTheme.rule('Label', ['legend']).setAll({

      fill: am5.color(chartColors.text),

      opacity: 1,

    });

    myTheme.rule('Label', ['legend', 'stocklegend']).setAll({

      fill: am5.color(chartColors.text),

      opacity: 1,

    });

    myTheme.rule('Label', ['legend', 'value', 'label', 'stocklegend']).setAll({

      fill: am5.color(chartColors.text),

      opacity: 1,

    });



    // Price-based overlay indicators default to #.00 — too coarse for FX (shows 1.17

    // instead of 1.16520). Match the active symbol's digit count.

    const priceDigits = Math.max(0, Number(symbolInfo?.digit) || 5);

    const priceLegendFmt = `#.${'0'.repeat(priceDigits)}`;

    const priceLegendValue = `[{seriesColor} bold]{valueY.formatNumber('${priceLegendFmt}')}[/]`;

    myTheme.rule('LineSeries', ['movingaverage']).setAll({

      legendValueText: priceLegendValue,

    });

    myTheme.rule('LineSeries', ['bollingerbands']).setAll({

      legendValueText: `[{lowerColor} bold]{lower.formatNumber('${priceLegendFmt}')}[/] [{seriesColor} bold]{valueY.formatNumber('${priceLegendFmt}')}[/] [{upperColor} bold]{upper.formatNumber('${priceLegendFmt}')}[/]`,

    });

    myTheme.rule('LineSeries', ['indicator', 'movingaverageenvelope']).setAll({

      legendValueText: `[{lowerColor} bold]{lower.formatNumber('${priceLegendFmt}')}[/] [{seriesColor} bold]{valueY.formatNumber('${priceLegendFmt}')}[/] [{upperColor} bold]{upper.formatNumber('${priceLegendFmt}')}[/]`,

    });

    myTheme.rule('LineSeries', ['vwap']).setAll({

      legendValueText: priceLegendValue,

    });

    // One-percent reversals make the initial ZigZag useful on intraday charts.
    // Explicit saved/user settings continue to take precedence over theme defaults.
    myTheme.rule('ZigZag').set('deviation', 1);
    myTheme.rule('LineSeries', ['zigzag']).set('legendValueText', priceLegendValue);

    myTheme.rule('LineSeries', ['supertrend']).setAll({

      legendValueText: priceLegendValue,

    });



    myTheme.rule('Button', ['control', 'settings']).setAll({

      stateAnimationDuration: 0,

      interpolationDuration: 0,

    });

    myTheme.rule('Button', ['control', 'settings']).states.create('default', {

      stateAnimationDuration: 0,

    });

    myTheme.rule('Button', ['control', 'settings']).states.create('hover', {

      stateAnimationDuration: 0,

    });

    myTheme.rule('Graphics', ['settings', 'button', 'icon']).setAll({

      stroke: am5.color('#8b92b0'),

      fill: am5.color(chartColors.panel),

      fillOpacity: 1,

      strokeOpacity: 0.85,

      strokeWidth: 0.5,

      stateAnimationDuration: 0,

      interpolationDuration: 0,

    });

    myTheme.rule('Graphics', ['settings', 'button', 'icon']).states.create('default', {

      stateAnimationDuration: 0,

    });

    myTheme.rule('Graphics', ['control', 'button', 'icon']).states.create('hover', {

      stroke: am5.color(chartColors.text),

      fill: am5.color(chartColors.panel),

      fillOpacity: 1,

      strokeOpacity: 1,

      stateAnimationDuration: 0,

    });



    // Stock controls default to half opacity, which washes out on a light plot.

    myTheme.rule('PanelControls').set('opacity', 1);

    myTheme.rule('Graphics', ['control', 'button', 'icon']).setAll({

      stroke: am5.color(chartColors.muted),

      strokeOpacity: 1,

    });

    myTheme.rule('Graphics', ['settings', 'button', 'icon']).setAll({

      stroke: am5.color(chartColors.muted),

      strokeOpacity: 1,

      strokeWidth: 1,

    });



    // Stock indicators ship with fixed colors, some of which are too faint

    // against the light chart and too dim against the dark chart. Give each

    // indicator theme-aware defaults while leaving explicit user colors intact.

    const indicatorPalette = theme === 'light'

      ? {

          blue: 0x2563eb,

          purple: 0x7c3aed,

          orange: 0xc2410c,

          teal: 0x0f766e,

          pink: 0xbe185d,

          cyan: 0x0369a1,

          slate: 0x475569,

          positive: 0x15803d,

          negative: 0xdc2626,

        }

      : {

          blue: 0x60a5fa,

          purple: 0xc4b5fd,

          orange: 0xfdba74,

          teal: 0x5eead4,

          pink: 0xf9a8d4,

          cyan: 0x7dd3fc,

          slate: 0xcbd5e1,

          positive: 0x4ade80,

          negative: 0xfb7185,

        };

    const indicatorDefaults = [

      ['MovingAverage', { seriesColor: 'blue' }],

      ['MACross', { seriesColor: 'purple', fastColor: 'cyan' }],

      ['ZigZag', { seriesColor: 'slate' }],

      ['MovingAverageEnvelope', { seriesColor: 'blue', upperColor: 'orange', lowerColor: 'teal' }],

      ['MovingAverageDeviation', { increasingColor: 'positive', decreasingColor: 'negative' }],

      ['StandardDeviation', { seriesColor: 'purple' }],

      ['TypicalPrice', { seriesColor: 'teal' }],

      ['AverageTrueRange', { seriesColor: 'orange' }],

      ['Trix', { seriesColor: 'blue', signalColor: 'orange' }],

      ['MedianPrice', { seriesColor: 'teal' }],

      ['VWAP', { seriesColor: 'pink' }],

      ['AccumulationDistribution', { seriesColor: 'slate' }],

      ['DisparityIndex', { seriesColor: 'purple' }],

      ['ChaikinMoneyFlow', { seriesColor: 'blue' }],

      ['ChaikinOscillator', { seriesColor: 'orange' }],

      ['BullBearPower', { seriesColor: 'teal' }],

      ['OnBalanceVolume', { seriesColor: 'purple' }],

      ['PVT', { seriesColor: 'blue' }],

      ['BollingerBands', { seriesColor: 'purple', upperColor: 'orange', lowerColor: 'teal' }],

      ['AccelerationBands', { seriesColor: 'blue', upperColor: 'orange', lowerColor: 'purple' }],

      ['RelativeStrengthIndex', { overSoldColor: 'negative', overBoughtColor: 'cyan', seriesColor: 'purple', smaColor: 'orange' }],

      ['Momentum', { seriesColor: 'blue' }],

      ['SuperTrend', { upperColor: 'negative', lowerColor: 'positive' }],
      ['ZigZag', { seriesColor: 'purple' }],

      ['WilliamsR', { overSoldColor: 'negative', overBoughtColor: 'cyan', seriesColor: 'purple' }],

      ['CommodityChannelIndex', { overSoldColor: 'negative', overBoughtColor: 'cyan', seriesColor: 'blue' }],

      ['StochasticOscillator', { overSoldColor: 'negative', overBoughtColor: 'cyan', seriesColor: 'blue', slowColor: 'orange' }],

      ['StochasticMomentumIndex', { overSoldColor: 'negative', overBoughtColor: 'cyan', seriesColor: 'purple', emaColor: 'orange' }],

      ['AccumulativeSwingIndex', { positiveColor: 'positive', negativeColor: 'negative' }],

      ['Aroon', { upColor: 'positive', downColor: 'negative' }],

      ['AwesomeOscillator', { increasingColor: 'positive', decreasingColor: 'negative' }],

      ['HeikinAshi', { increasingColor: 'positive', decreasingColor: 'negative' }],

      ['Volume', { increasingColor: 'positive', decreasingColor: 'negative' }],

      ['VolumeProfile', { upColor: 'positive', downColor: 'negative' }],

      ['MACD', { increasingColor: 'positive', decreasingColor: 'negative', seriesColor: 'blue', signalColor: 'orange' }],

    ];

    indicatorDefaults.forEach(([indicatorName, colorSettings]) => {

      const themedColors = Object.fromEntries(

        Object.entries(colorSettings).map(([key, paletteKey]) => [key, am5.color(indicatorPalette[paletteKey])])

      );

      myTheme.rule(indicatorName).setAll(themedColors);

    });



    // Set themes

    root.setThemes(

      mobileMode

        ? [am5themes_Responsive.new(root), am5themes_Dark.new(root), myTheme]

        : [am5themes_Animated.new(root), am5themes_Dark.new(root), myTheme],

    );



    // Keep default canvas controls and axis masks on the same surface as the plot.

    root.interfaceColors.setAll({

      background: am5.color(chartColors.bg),

      alternativeBackground: am5.color(chartColors.panel),

      text: am5.color(chartColors.text),

      alternativeText: am5.color(chartColors.text),

      secondaryButton: am5.color(chartColors.bg),

      secondaryButtonText: am5.color(chartColors.muted),

    });

    root.container.set("background", am5.Rectangle.new(root, {

      fill: am5.color(chartColors.bg) // Updated to match theme $bodyColor

    }));



    //#region Create a stock chart

    let stockChart = root.container.children.push(

      am5stock.StockChart.new(root, {

        paddingLeft: 0,

        // StockChart adds its own 18px gutter outside the panel's price axis.

        paddingRight: 0,

        stockNegativeColor: am5.color(selectedStyle.sellColor),

        stockPositiveColor: am5.color(selectedStyle.buyColor),

      }),

    );



    setStockChart2(stockChart);

    const volumeGuards = new Map();

    const watchVolumeIndicator = indicator => {

      if (volumeGuards.has(indicator)) return;

      const colors = configureIndicatorColors(indicator);
      const calculations = configureIndicatorCalculations(indicator);
      const liveValues = configureIndicatorLiveValues(indicator);
      const volume = configureVolumeIndicatorData(indicator);
      volumeGuards.set(indicator, { dispose() {
        colors.dispose();
        liveValues.dispose();
        volume.dispose();
        calculations.dispose();
      }});

    };

    stockChart.indicators.each(watchVolumeIndicator);

    const volumeListEvents = stockChart.indicators.events.onAll(event => {

      if (event.type === 'push' || event.type === 'insertIndex' || event.type === 'setIndex') {

        watchVolumeIndicator(event.newValue);

      }

      for (const [indicator, guard] of volumeGuards) {

        if (!stockChart.indicators.values.includes(indicator)) {

          guard.dispose();

          volumeGuards.delete(indicator);

        }

      }

    });

    root.addDisposer(new am5.Disposer(() => {

      volumeListEvents.dispose();

      volumeGuards.forEach(guard => guard.dispose());

      volumeGuards.clear();

    }));



    // Set global number format

    root.numberFormatter.set('numberFormat', numberFormat);



    let mainPanel = stockChart.panels.push(

      am5stock.StockPanel.new(root, {

        panX: true,

        panY: true,

        wheelX: 'panX',

        wheelY: 'zoomX',

        pinchZoomX: true,

        paddingTop: 0,

        paddingLeft: 0,

      }),

    );



    // Create value/vertical axis

    let valueAxis = mainPanel.yAxes.push(

      am5xy.ValueAxis.new(root, {

        start: 0.9, //show 10% candles on load

        // Keep the price domain tied to visible data and padding, not rounded

        // grid intervals which change when the chart becomes taller/shorter.

        strictMinMaxSelection: true,

        renderer: am5xy.AxisRendererY.new(root, {

          pan: 'zoom',

          crisp: true,

          // Keep the plot/price-axis seam blended into the plot in light mode;

          // using the white panel color produced a bright border line.

          stroke: am5.color(chartColors.axisStroke),

          strokeOpacity: 1,

          strokeWidth: 1,

        }),

        extraMin: 0.1, // adds some space for for main series

        extraMax: 0.4, // adds some space for for main series

        tooltip: am5.Tooltip.new(root, {}),

        numberFormat: numberFormat,

        // maxPrecision: 8,

        // extraTooltipPrecision: 4,

      }),

    );



    // Create date/horizontal axis

    let dateAxis = mainPanel.xAxes.push(

      am5xy.GaplessDateAxis.new(root, {

        start: zoomRange || 0.9, //show 10% candles on load

        minZoomCount: mobileMode ? 30 : 10,

        baseInterval: getChartInterval(selectedTimeFrame),

        renderer: am5xy.AxisRendererX.new(root, {

          pan: 'zoom',

          stroke: am5.color(chartColors.axisStroke),

          strokeOpacity: 1,

          strokeWidth: 1,

          minGridDistance: mobileMode ? 50 : 80,

          // minorGridEnabled: true,

        }),

        crisp: true,

        tooltip: am5.Tooltip.new(root, {}),

        end: 1.1, // increase the end value to add space on the right side

      }),

    );



    // Resizing changes candle spacing, not the selected time range. Leave the

    // axis start/end untouched so expand/restore shows the same candles.



    configureChartTimeAxis(dateAxis, (value, format) => root.dateFormatter.format(value, format));





    // add range which will show current value

    currentValueDataItem = valueAxis.createAxisRange(

      valueAxis.makeDataItem({ value: 0 }),

    );



    currentValueDataItemNewRef.current = valueAxis.createAxisRange(

      valueAxis.makeDataItem({ value: 0 }),

    );





    currentValueDataItem2Ref.current = currentValueDataItem;



    // currentValueDataItem.get('label').set('visible', false);

    // currentValueDataItemNewRef.current.get('label').set('visible', false);



    currentLabel = currentValueDataItem.get('label');

    currentLabelNew = currentValueDataItemNewRef.current.get('label');



    currentLabelNew2Ref.current = currentLabelNew;

    currentLabel2Ref.current = currentLabel;

  //   if (currentLabelNew) {

  //     currentLabelNew.setAll({

  //       fill: am5.color(0xffffff),

  //       background: am5.Rectangle.new(root, { fill: am5.color(0x000000) }),

  // fillOpacity: 0.5

  //     });

  //   }

  //   if (currentLabel) {

  //     currentLabel.setAll({

  //       fill: am5.color(0xffffff),

  //       background: am5.Rectangle.new(root, { fill: am5.color(0x000000) }),

  //     });

  //   }





  if (currentLabelNew) {

  currentLabelNew.setAll({

    fill: am5.color(chartColors.text), // Updated to match theme $boldTextColor

    background: am5.Rectangle.new(root, {

      fill: am5.color(chartColors.bg),

      fillOpacity: 1,

      minWidth: 60, // Limit width to prevent overflow

      // cornerRadius: 5, // Rounded corners

    }),

    dy: -13, // Adjust vertical position to stack above

  });

}



if (currentLabel) {

  currentLabel.setAll({

    fill: am5.color(chartColors.text), // Updated to match theme $boldTextColor

    background: am5.Rectangle.new(root, {

      fill: am5.color(chartColors.bg),

      fillOpacity: 1,

      minWidth: 60

      // cornerRadius: 15, // Rounded corners

    }),

    dy: 0, // Base position

  });

}



    let currentGridNew = currentValueDataItemNewRef.current.get('grid');

    let currentGrid = currentValueDataItem.get('grid');



    if (currentGridNew) {

      currentGridNew.setAll({

        stroke: am5.color(selectedStyle.buyColor),

        strokeOpacity: 0.5,

        // strokeDasharray: [2, 5]

      });

    }



    if (currentGrid) {

      currentGrid.setAll({

        stroke: am5.color(selectedStyle.sellColor),

        strokeOpacity: 1,

      });

    }



//     const chart = valueAxis.chart; // Get the chart instance

// const plotContainer = chart.plotContainer;



// Function to create a label at a specific price

// function createPriceLabel(price, text, color, dyOffset) {

//   const yPosition = valueAxis.valueToPosition(price); // Convert price to y-position

//   const label = am5.Label.new(root, {

//     text: text,

//     fill: am5.color(0xffffff), // White text

//     x: am5.percent(5), // Position the label slightly inside the chart (adjust as needed)

//     y: yPosition, // Y-position based on price

//     dy: dyOffset, // Offset to stack labels

//     centerY: yPosition, // Align vertically with the price level

//     background: am5.Rectangle.new(root, {

//       fill: am5.color(color), // Background color (e.g., green for bid, red for ask)

//       fillOpacity: 0.7,

//       cornerRadius: 5,

//     }),

//     paddingLeft: 5,

//     paddingRight: 5,

//     paddingTop: 2,

//     paddingBottom: 2,

//   });



//   plotContainer.children.push(label);

//   return label;

// }



// // Create labels for ask and bid prices

// const bidLabel = createPriceLabel(

//   4.854,

//   `Bid: 134`,

//   selectedStyle.sellColor, // Use your bid color

//   0 // No offset for bid

// );



// const askLabel = createPriceLabel(

//   4.855,

//   `Ask: 123`,

//   selectedStyle.buyColor, // Use your ask color

//   -20 // Offset ask label above bid

// );



// Optional: Update labels dynamically if prices change

// function updateLabels(newAskPrice, newBidPrice) {

//   const newAskY = valueAxis.valueToPosition(newAskPrice);

//   const newBidY = valueAxis.valueToPosition(newBidPrice);



//   askLabel.set('y', newAskY);

//   askLabel.set('centerY', newAskY);

//   askLabel.set('text', `Ask: ${newAskPrice}`);



//   bidLabel.set('y', newBidY);

//   bidLabel.set('centerY', newBidY);

//   bidLabel.set('text', `Bid: ${newBidPrice}`);

// }



    // Add series

    let valueSeries;

    let volumeSeries;

    const textColor = am5.color(chartColors.text) // Updated to match theme $boldTextColor



    const createPriceTooltip = (force = false) => {

      if (!showTooltip && !force) return undefined;

      const light = theme === 'light';

      const muted = light ? '#526176' : '#929db2';

      const tooltip = am5.Tooltip.new(root, {

        pointerOrientation: 'down',

        getFillFromSprite: false, getStrokeFromSprite: false,

        autoTextColor: false, getLabelFillFromSprite: false,

        animationDuration: 0, stateAnimationDuration: 0,

        layout: root.verticalLayout,

        paddingTop: 8, paddingBottom: 8, paddingLeft: 10, paddingRight: 10,

        labelText: `[bold]{valueX.formatDate('MMM dd, HH:mm')}[/]`,

      });

      tooltip.label.setAll({

        fontSize: 11, fontFamily: 'Arial, sans-serif',

        fill: am5.color(light ? '#1e293b' : '#eef1f8'),

        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,

      });

      tooltip.label.set('paddingBottom', 5);

      const columns = tooltip.children.push(am5.Container.new(root, { layout: root.horizontalLayout }));

      const cellStyle = { fontSize: 11, fontFamily: 'Arial, sans-serif', lineHeight: 1.35,

        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 };

      columns.children.push(am5.Label.new(root, {

        ...cellStyle, text: 'Open\nHigh\nLow\nClose', fill: am5.color(muted), paddingRight: 14,

      }));

      const numbers = columns.children.push(am5.Label.new(root, {

        ...cellStyle, textAlign: 'right', fill: am5.color(light ? '#1e293b' : '#eef1f8'),

      }));

      tooltip.label.events.on('dataitemchanged', () => {

        const item = tooltip.label.dataItem;

        numbers.set('text', ['openValueY', 'highValueY', 'lowValueY', 'valueY'].map(field => {

          const value = item?.get(field);

          return Number.isFinite(value) ? root.numberFormatter.format(value, '#,###.########') : '—';

        }).join('\n'));

      });

      tooltip.get('background').setAll({

        fill: am5.color(light ? '#fcfcfd' : '#1a1f36'), fillOpacity: 0.96,

        stroke: am5.color(light ? '#cbd5e1' : '#414960'), strokeOpacity: 0.6,

        cornerRadiusTL: 8, cornerRadiusTR: 8, cornerRadiusBL: 8, cornerRadiusBR: 8,

        pointerLength: 7, pointerBaseWidth: 12,

      });

      configureCandleTooltipPlacement(tooltip, mainPanel);

      return tooltip;

    };

    const clickPriceTooltip = createPriceTooltip(true);

    root.addDisposer(clickPriceTooltip);

    clickPriceTooltip.hide(0);

    const hideClickedCandle = () => clickPriceTooltip.hide(0);

    mainPanel.plotContainer.events.on('pointerdown', hideClickedCandle);

    mainPanel.events.on('panstarted', hideClickedCandle);

    root.dom.addEventListener('wheel', hideClickedCandle, { passive: true });

    root.dom.addEventListener('pointerleave', hideClickedCandle);

    root.addDisposer(new am5.Disposer(() => {

      root.dom.removeEventListener('wheel', hideClickedCandle);

      root.dom.removeEventListener('pointerleave', hideClickedCandle);

    }));

    const bindCandleClick = series => {

      if (!series.columns) return;

      series.columns.template.events.on('click', event => {

        if (drawingControl.getPrivate('toolControl')?.get('active') || !event.target.dataItem) return;

        series.get('tooltip')?.hide(0);

        clickPriceTooltip._setDataItem(event.target.dataItem);

        clickPriceTooltip.set('pointTo', event.point);

        clickPriceTooltip.show(0);

      });

    };

  valueSeries = mainPanel.series.push(

    am5xy.CandlestickSeries.new(root, {

      name: selectedAuthSymbol,

      clustered: false,

      valueXField: 'Date',

      valueYField: 'Close',

      highValueYField: 'High',

      lowValueYField: 'Low',

      openValueYField: 'Open',

      calculateAggregates: true,

      xAxis: dateAxis,

      yAxis: valueAxis,

        tooltip: createPriceTooltip(),

    }),

  );



    mainPanel.plotContainer.get('background')?.setAll({ interactive: true, cursorOverStyle: 'crosshair' });

    valueSeries.columns.template.setAll({ interactive: true, cursorOverStyle: 'pointer' });

    bindCandleClick(valueSeries);



    // Set main value series

    stockChart.set('stockSeries', valueSeries);

    // volumeSeries is created below; set again after that so volume indicators work



    // Overlay MA/BB/VWAP legend — same construction as RSI (ChartIndicator).

    // Offset below #chartcontrols (absolute over the plot) so cards are not under

    // the toolbar hit-area and stay as sharp as RSI pane legends.

    let valueLegend = mainPanel.topPlotContainer.children.insertIndex(

      0,

      am5stock.StockLegend.new(root, {

        stockChart: stockChart,

        y: 42,

      }),

    );

    // Keep overlay cards solid/opaque like RSI pane legends (no soft glass look).

    valueLegend.itemContainers.template.setAll({ opacity: 1 });

    valueLegend.itemContainers.template.setup = function (target) {

      target.set('opacity', 1);

      // Replace default background — theme tags alone can leave soft shadow / translucent fill.

      target.set(

        'background',

        am5.RoundedRectangle.new(root, {

          fill: am5.color(chartColors.panel),

          fillOpacity: 0,

          cornerRadiusTL: 4,

          cornerRadiusTR: 4,

          cornerRadiusBL: 4,

          cornerRadiusBR: 4,

          shadowBlur: 0,

          shadowOpacity: 0,

          shadowOffsetX: 0,

          shadowOffsetY: 0,

        }),

      );

    };



    // For Bid Price (lower one)

// let bidBullet = valueSeries.bullets.push(function () {

//   return am5.Bullet.new(root, {

//     locationY: 1, // bottom

//     sprite: am5.Label.new(root, {

//       text: "Bid: 100.50",

//       fill: am5.color(0xffffff),

//       background: am5.Rectangle.new(root, {

//         fill: am5.color(0xff0000),

//       }),

//       centerX: am5.p100,

//       centerY: am5.p100,

//       x: am5.p100, // move to right edge

//       dy: -20 // adjust vertical position

//     })

//   });

// });



// // For Ask Price (above Bid)

// let askBullet = valueSeries.bullets.push(function () {

//   return am5.Bullet.new(root, {

//     locationY: 1,

//     sprite: am5.Label.new(root, {

//       text: "Ask: 100.70",

//       fill: am5.color(0xffffff),

//       background: am5.Rectangle.new(root, {

//         fill: am5.color(0x00ff00),

//       }),

//       centerX: am5.p100,

//       centerY: am5.p100,

//       x: am5.p100,

//       dy: -40 // positioned above Bid

//     })

//   });

// });



// let bidLabel = am5.Label.new(root, {

//   text: `Bid ${406.1}`, // set bidPrice dynamically

//   fontSize: 10,

//   background: am5.RoundedRectangle.new(root, {

//     fill: am5.color(0x00ff00), // green for bid

//     fillOpacity: 0.8,

//   }),

//   fill: am5.color(0x000000),

//   paddingTop: 3,

//   paddingBottom: 3,

//   paddingLeft: 6,

//   paddingRight: 6,

//   x: am5.percent(100),

//   centerX: am5.percent(100),

//   y: valueAxis.valueToPosition(406.1) * stockChart.plotContainer.height() - 20, // position a bit above

//   centerY: am5.p100

// });



// let askLabel = am5.Label.new(root, {

//   text: `Ask ${406.2}`, // set askPrice dynamically

//   fontSize: 10,

//   background: am5.RoundedRectangle.new(root, {

//     fill: am5.color(0xff0000), // red for ask

//     fillOpacity: 0.8,

//   }),

//   fill: am5.color(0x000000),

//   paddingTop: 3,

//   paddingBottom: 3,

//   paddingLeft: 6,

//   paddingRight: 6,

//   x: am5.percent(100),

//   centerX: am5.percent(100),

//   y: valueAxis.valueToPosition(406.2) * stockChart.plotContainer.height(),

//   centerY: am5.p100

// });



// Add to chart

// stockChart.plotContainer.children.push(bidLabel);

// stockChart.plotContainer.children.push(askLabel);





    // Add cursor(s)

    let cursor = mainPanel.set(

      'cursor',

      am5xy.XYCursor.new(root, {

        // Follow the pointer itself, not animated/snapped axis tooltips.

        behavior: 'none',

      }),

    );



    cursor.lineX.set("stroke", am5.color(chartColors.muted)); // Updated to match theme $normalTextColor

    cursor.lineY.set("stroke", am5.color(chartColors.muted)); // Updated to match theme $normalTextColor



    cursor.lineX.set("strokeOpacity", 1);

    cursor.lineY.set("strokeOpacity", 1);



    // Regular ticks are not cursor tooltips. Opaque backgrounds on cloned labels

    // can leave a blank rectangle at the clipped end of the date axis.

    [dateAxis, valueAxis].forEach(axis => {

      axis.get('renderer').labels.template.setAll({

        fill: am5.color(chartColors.text),

        paddingTop: 3,

        paddingBottom: 3,

        paddingLeft: 6,

        paddingRight: 6,

      });

      const axisTooltip = axis.get('tooltip');

      axisTooltip.setAll({ getFillFromSprite: false, autoTextColor: false, animationDuration: 0 });

      axisTooltip.label.set('fill', am5.color(chartColors.text));

      axisTooltip.get('background').setAll({

        fill: am5.color(chartColors.panel),

        fillOpacity: 1,

        stroke: am5.color(chartColors.muted),

        strokeOpacity: 0.25,

      });

    });



    //#region Zoom Scrollbar Setup------------------------------------------------



    const bgColor = getComputedStyle(document.body).backgroundColor;



    var scrollbarX = am5xy.XYChartScrollbar.new(root, {

      orientation: 'horizontal',

      width: 100,

      x: am5.p100,

      centerX: am5.p100,

      dx: -65,

      y: 30,

      centerY: am5.p100,

      visible: !mobileMode,

    });



    scrollbarX.thumb.setAll({

      fill: am5.color(chartColors.bg), // Updated to match theme $bodyColor

      fillOpacity: 0,

    });



    scrollbarX.startGrip.setAll({

      visible: true,

      scale: 0.6,

    });



    scrollbarX.endGrip.setAll({

      visible: true,

      scale: 0.6,

    });



    scrollbarX.get('background').setAll({

      fill: am5.color(chartColors.panel), // Updated to match theme $firstBox

      fillOpacity: 0,

      cornerRadiusTR: 100,

      cornerRadiusBR: 100,

      cornerRadiusTL: 100,

      cornerRadiusBL: 100,

    });



    // mainPanel.set('scrollbarX', scrollbarX);



    //#endregion



    //#region Create volume axis

    // -------------------------------------------------------------------------------

    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/

    var volumeAxisRenderer = am5xy.AxisRendererY.new(root, {

      inside: true,

    });



    volumeAxisRenderer.labels.template.set('forceHidden', true);

    volumeAxisRenderer.grid.template.set('forceHidden', true);



    var volumeValueAxis = mainPanel.yAxes.push(

      am5xy.ValueAxis.new(root, {

        numberFormat: '#.#a',

        height: am5.percent(20),

        y: am5.percent(100),

        centerY: am5.percent(100),

        renderer: volumeAxisRenderer,

      }),

    );



    //#region Add series

    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/

    volumeSeries = mainPanel.series.push(

      am5xy.ColumnSeries.new(root, {

        name: 'Volume',

        clustered: false,

        valueXField: 'Date',

        valueYField: 'Volume',

        xAxis: dateAxis,

        yAxis: volumeValueAxis,

        legendValueText: "[bold]{valueY.formatNumber('#,###.0a')}[/]",

      }),

    );



    volumeSeries.columns.template.setAll({

      strokeOpacity: 0,

      fillOpacity: 0.2,

    });



    // color columns by stock rules

    volumeSeries.columns.template.adapters.add('fill', function (fill, target) {

      return am5.color(

        getComputedStyle(document.querySelector('.left-nav')).color,

      );

    });

    volumeSeries.set('forceHidden', true);

    stockChart.set('volumeSeries', volumeSeries);

    volumeSeriesRef.current = volumeSeries;



    // Set up symbol searchable drop down list

    let symbolSearchList = am5stock.DropdownListControl.new(root, {

      stockChart: stockChart,

      name: selectedAuthSymbol,

      fixedLabel: true,

      searchable: true,

      currentItem: selectedAuthSymbol,

      // items: symbolNames,

      items: symbolNames.map((symbolName) => ({

        id: symbolName,

        label: symbolName,

        className: symbolName === selectedAuthSymbol ? "selected-symbol" : ""

      })),

    });



    // amCharts default search uses innerText + RegExp on every row, which lags on large symbol lists.

    const symbolDropdown = symbolSearchList.getPrivate('dropdown');

    if (symbolDropdown) {

      symbolDropdown._filterItems = function (search) {

        const list = this.getPrivate('list');

        if (!list) return;

        const needle = String(search || '').trim().toLowerCase();

        const items = list.children;

        let visible = 0;

        for (let i = 0; i < items.length; i++) {

          const item = items[i];

          const text = (

            item.getAttribute('data-am5-title')

            || item.getAttribute('title')

            || item.textContent

            || ''

          ).toLowerCase();

          const show = !needle || text.includes(needle);

          item.style.display = show ? '' : 'none';

          if (show) visible += 1;

        }

        list.classList.toggle('am5stock-list-empty', needle.length > 0 && visible === 0);

      };

    }



    // Function to update dropdown items with current selection

    const updateDropdownItems = (newSelectedSymbol = selectedAuthSymbol) => {

      const updatedItems = symbolNames.map((symbolName) => {

        const isSelected = symbolName === newSelectedSymbol;

        return {

          id: symbolName,

          label: symbolName,

          className: isSelected ? "selected-symbol" : ""

        };

      });

      symbolSearchList.set('items', updatedItems);

      symbolSearchList.set('currentItem', newSelectedSymbol);

    };



    // Add click outside functionality to close dropdown

    const handleClickOutside = (event) => {

      const chartControls = document.getElementById('chartcontrols');

      if (chartControls && !chartControls.contains(event.target)) {

        // Close any open dropdowns

        if (symbolSearchList && symbolSearchList.isOpen && symbolSearchList.isOpen()) {

          symbolSearchList.close();

        }

      }

    };



    // Add event listener for click outside

    document.addEventListener('click', handleClickOutside);



    let clickOutsideCleanup = () => {

      document.removeEventListener('click', handleClickOutside);

      eaChartToolbarTeardown();

    };



    symbolSearchList.events.on('selected', function (ev) {

      // An item selected

      const matchingSymbol = symbolWithCategories.find(

        (symbol) => symbol.name === ev.item.label,

      );

      if (matchingSymbol) {

        setSelectedCategoryId(matchingSymbol.symbol_category);

        setAuthSelectedCategory(matchingSymbol.symbol_category);

        setSelectedSymbolSession(matchingSymbol.is_session_active);



        localStorage.setItem('symbol_id', matchingSymbol.id);

        localStorage.setItem('category', matchingSymbol.symbol_category);

      }

      updateSymbolName(ev.item.label);

      setAuthSelectedSymbol(ev.item.label);



      // Update dropdown items immediately to show selection

      updateDropdownItems(ev.item.label);

    });



    //#region Series type switcher

    let seriesSwitcher = am5stock.SeriesTypeControl.new(root, {

      stockChart: stockChart,

    });



    seriesSwitcher.events.on('selected', function (ev) {

      newSetSeriesType(ev.item.id);

      setLineCandle(ev.item.id);

    });



    function getNewSettings(series) {

      let newSettings = {};

      am5.array.each(

        [

          'name',

          'valueYField',

          'highValueYField',

          'lowValueYField',

          'openValueYField',

          'calculateAggregates',

          'valueXField',

          'xAxis',

          'yAxis',

          'legendValueText',

          'stroke',

          'fill',

        ],

        function (setting) {

          newSettings[setting] = series.get(setting);

        },

      );

      return newSettings;

    }



    let wheelTimeout;

    mainPanel.events.on('wheelended', function () {

      if (wheelTimeout) {

        mainPanel.removeDispose(wheelTimeout);
        wheelTimeout = undefined;

      }



      wheelTimeout = mainPanel.setTimeout(function () {
        wheelTimeout = undefined;

        loadChartData(valueSeries, dateAxis, true);

      }, 50);  // Delay slightly to prevent triggering multiple calls

    });



    mainPanel.events.on('panended', function () {

      loadChartData(valueSeries, dateAxis, true);

    });



    function newSetSeriesType(seriesType) {

      // Get current series and its settings

      let currentSeries = stockChart.get('stockSeries');

      let newSettings = getNewSettings(currentSeries);



      // Keep the current axis populated until the replacement has validated.

      const data = [...currentSeries.data.values];



      // Create new series

      let series;

      switch (seriesType) {

        case 'line': {

          series = mainPanel.series.push(

            am5xy.LineSeries.new(root, newSettings),

          );

          break;

        }

        case 'candlestick': {

          newSettings.clustered = false;

          series = mainPanel.series.push(

            am5xy.CandlestickSeries.new(root, newSettings),

          );

          break;

        }

        case 'procandlestick': {

          newSettings.clustered = false;

          series = mainPanel.series.push(

            am5xy.CandlestickSeries.new(root, newSettings),

          );

          if (seriesType == 'procandlestick') {

            series.columns.template.get('themeTags').push('pro');

          }

          break;

        }

        case 'ohlc': {

          newSettings.clustered = false;

          series = mainPanel.series.push(

            am5xy.OHLCSeries.new(root, newSettings),

          );

          break;

        }

        default: {

          break;

        }

      }



      // Set new series as stockSeries

      if (series) {

        // Each series owns/disposes its tooltip, so never reuse the old instance.

        series.set('tooltip', createPriceTooltip());

        hideClickedCandle();

        bindCandleClick(series);

        series.events.once('datavalidated', () => {

          if (!currentSeries.isDisposed()) mainPanel.series.removeValue(currentSeries);

        });

        liveTickIdentityRef.current = createLiveTickIdentity();

        series.data.setAll(data);

        valueSeries = series;

        valueSeriesRef.current = series;

        stockChart.set('stockSeries', series);

        if (loadedChartRequestKeyRef.current !== chartRequestKey) loadChartData(series);

        createChartBullets();

        let cursor = mainPanel.get('cursor');

        if (cursor) {

          cursor.set('snapToSeries', []);

          series.columns?.template.setAll({ interactive: true, cursorOverStyle: 'pointer' });

        }

      }

    }



    //set intervals...

    let intervalSwitcher = am5stock.IntervalControl.new(root, {

      stockChart: stockChart,

      currentItem: selectedTimeFrame,

      items: [

        {

          id: '1m',

          label: '1m',

          className: `interval-selected-${selectedTimeFrame === '1m'}`,

          interval: { timeUnit: 'minute', count: 1 },

        },

        {

          id: '5m',

          label: '5m',

          className: `interval-selected-${selectedTimeFrame === '5m'}`,

          interval: { timeUnit: 'minute', count: 5 },

        },

        {

          id: '15m',

          label: '15m',

          className: `interval-selected-${selectedTimeFrame === '15m'}`,

          interval: { timeUnit: 'minute', count: 15 },

        },

        {

          id: '30m',

          label: '30m',

          className: `interval-selected-${selectedTimeFrame === '30m'}`,

          interval: { timeUnit: 'minute', count: 30 },

        },

        {

          id: '1h',

          label: '1h',

          className: `interval-selected-${selectedTimeFrame === '1h'}`,

          interval: { timeUnit: 'hour', count: 1 },

        },

        {

          id: '4h',

          label: '4h',

          className: `interval-selected-${selectedTimeFrame === '4h'}`,

          interval: { timeUnit: 'hour', count: 4 },

        },

        {

          id: '1d',

          label: '1d',

          className: `interval-selected-${selectedTimeFrame === '1d'}`,

          interval: { timeUnit: 'day', count: 1 },

        },

      ],

    });



    intervalSwitcher.events.on('selected', function (ev) {

      updateChartTimeFrame(ev.item.id);

      setAuthTimeFrame(ev.item.id);

      localStorage.setItem('timeFrame', ev.item.id);

    });



    const drawingInk = am5.color(theme === 'light' ? 0x000000 : 0xffffff);

    const drawingControl = am5stock.DrawingControl.new(root, {

      stockChart: stockChart,

      scrollable: true,

      strokeColor: drawingInk,

      fillColor: drawingInk,

      labelFill: drawingInk,

    });

    configureDrawingPersistence(drawingControl);
    configureDrawingInteraction(drawingControl, { calloutFill: am5.color(chartColors.panel), lightTheme: theme === 'light', contrastColor: am5.color(0x374151), onFinished: () => {
      drawingControl.getPrivate('toolControl')?.setTool('Select');
      setDrawingSidebarActiveTool('');
    } });



    let drawingSubtoolbarCollapsed = false;

    let activeDrawingSidebarToolId = '';

    let drawingToolActiveHookBound = false;

    let wasDrawingControlActive = false;

    let drawingOpenAnimTimer = null;

    let scheduleDrawingSidebarSyncRef = () => {};



    const getDrawingSidebarPanel = () => {

      const button = drawingControl.getPrivate('toolControl')?.getPrivate('button');

      button?.setAttribute('data-drawing-tool-control', 'true');

      const panel = button?.querySelector('.am5stock-control-list-container');

      panel?.querySelectorAll('input').forEach(input => { input.placeholder = 'Search'; input.setAttribute('aria-label', 'Search drawing tools'); });

      return panel || null;

    };



    const applyDrawingSidebarActiveState = (panel) => {

      const list = panel?.querySelector('.am5stock-control-list');

      if (!list) return;



      const tools = drawingControl.getPrivate('toolControl')?.get('tools') || [];

      list.querySelectorAll(

        'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',

      ).forEach((item, index) => {

        const toolId = tools[index];

        item.classList.toggle(

          'draw-sidebar-tool-active',

          !!toolId && toolId === activeDrawingSidebarToolId,

        );

      });

    };



    const setDrawingSidebarActiveTool = (toolId, panel = getDrawingSidebarPanel()) => {

      activeDrawingSidebarToolId = toolId || '';

      applyDrawingSidebarActiveState(panel);

    };



    const ensureDrawingToolActiveHook = () => {

      const toolControl = drawingControl.getPrivate('toolControl');

      if (!toolControl || drawingToolActiveHookBound) return;

      drawingToolActiveHookBound = true;



      toolControl.events.on('selected', (ev) => {

        setDrawingSidebarActiveTool(ev.tool || '');

      });

    };



    const ensureDrawingSidebarExpandHook = (panel) => {

      if (!panel || panel.dataset.subtoolbarExpandHookBound) return;

      panel.dataset.subtoolbarExpandHookBound = '1';



      panel.addEventListener('click', (e) => {

        const item = e.target.closest(

          'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',

        );

        if (!item) return;



        const list = item.closest('.am5stock-control-list');

        const tools = drawingControl.getPrivate('toolControl')?.get('tools') || [];

        const items = list?.querySelectorAll(

          'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',

        );

        if (items) {

          items.forEach((entry, index) => {

            if (entry === item) {

              setDrawingSidebarActiveTool(tools[index] || '', panel);

            }

          });

        }



        if (drawingSubtoolbarCollapsed) {

          setDrawingSubtoolbarCollapsed(false);

        }

      });

    };



    const closeDrawingSubtoolbarDropdowns = () => {

      const drawingTools = document.querySelector('.am5stock-control-drawing-tools');

      if (!drawingTools) return;



      // Deactivate amCharts sub-toolbar controls so dropdown state stays in sync.

      [

        'strokeControl', 'strokeWidthControl', 'strokeDasharrayControl',

        'fillControl', 'iconControl', 'labelFillControl', 'labelFontSizeControl',

        'labelFontFamilyControl',

      ].forEach((key) => {

        const control = drawingControl.getPrivate(key);

        if (control?.get?.('active')) {

          control.set('active', false);

        }

      });



      // Fallback: hide open dropdown panels but keep the drawing sidebar list.

      drawingTools.querySelectorAll(

        ':scope > .am5stock:not([data-drawing-tool-control="true"]):not([data-drawing-tool-control="true"])',

      ).forEach((stock) => {

        stock.classList.remove('am5stock-control-button-active');

        const list = stock.querySelector(':scope > .am5stock-control-list-container');

        if (list) {

          list.style.display = 'none';

        }

      });

    };



    let subtoolbarMotionVersion = 0;

    let subtoolbarAnimations = [];

    const setDrawingSubtoolbarCollapsed = (collapsed) => {

      const el = document.querySelector('.am5stock-control-drawing-tools');

      const chartPane = document.querySelector('.chart-con');

      if (!el) return;

      const version = ++subtoolbarMotionVersion;

      subtoolbarAnimations.forEach(animation => animation.cancel());

      subtoolbarAnimations = [];

      const apply = () => {

        drawingSubtoolbarCollapsed = collapsed;

        el.setAttribute('data-collapsed', collapsed ? 'true' : 'false');

        chartPane?.setAttribute('data-drawing-subtoolbar-collapsed', collapsed ? 'true' : 'false');

        scheduleDrawingSidebarSyncRef();

      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { apply(); return; }

      const children = [...el.children].filter(child =>

        !child.hasAttribute('data-drawing-tool-control'));

      const animate = () => {

        subtoolbarAnimations = children.map((child, index) => child.animate(

          collapsed

            ? [{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: 'translateX(-24px)' }]

            : [{ opacity: 0, transform: 'translateX(-24px)' }, { opacity: 1, transform: 'translateX(0)' }],

          { duration: 220, delay: collapsed ? 0 : Math.min(index * 18, 100), easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' }

        ));

        Promise.all(subtoolbarAnimations.map(animation => animation.finished)).then(() => {

          if (version !== subtoolbarMotionVersion) return;

          if (collapsed) apply();

          subtoolbarAnimations.forEach(animation => animation.cancel());

          subtoolbarAnimations = [];

        }).catch(() => {});

      };

      if (collapsed) { closeDrawingSubtoolbarDropdowns(); animate(); }

      else {

        const wasCollapsed = drawingSubtoolbarCollapsed;

        apply();

        if (wasCollapsed) {

          // Apply the final fixed position before revealing any toolbar buttons.

          el.style.setProperty('transition', 'none', 'important');

          syncDrawingSidebarLayout();

          if (version === subtoolbarMotionVersion) animate();

        }

      }

    };



    const ensureDrawingSubtoolbarToggle = (drawingTools) => {

      if (!drawingTools) return;



      let toggle = drawingTools.querySelector(':scope > .draw-subtoolbar-toggle');

      if (!toggle) {

        toggle = document.createElement('button');

        toggle.type = 'button';

        toggle.className = 'draw-subtoolbar-toggle';

        toggle.setAttribute('data-tooltip', 'Collapse tools');

        toggle.setAttribute('aria-label', 'Collapse drawing tools');

        toggle.innerHTML =

          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 5.5L8 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        toggle.addEventListener('click', (e) => {

          e.preventDefault();

          e.stopPropagation();

          setDrawingSubtoolbarCollapsed(true);

        });

      }



      if (drawingTools.lastElementChild !== toggle) {

        drawingTools.appendChild(toggle);

      }



      if (!drawingTools.hasAttribute('data-collapsed')) {

        drawingTools.setAttribute('data-collapsed', drawingSubtoolbarCollapsed ? 'true' : 'false');

      }

    };



    const clearDrawingSubtoolbarLayout = (drawingTools) => {

      if (!drawingTools) return;

      [

        'position', 'top', 'left', 'right', 'width', 'maxWidth', 'height',

        'minHeight', 'maxHeight', 'margin', 'zIndex',

      ].forEach((prop) => drawingTools.style.removeProperty(prop));

    };



    const applyDrawingSubtoolbarLayout = (drawingTools, chartPane, sidebarW, subtoolbarTop, subRowHeight) => {

      if (!drawingTools || getComputedStyle(drawingTools).display === 'none') return;



      // The drawing sidebar dropdown lives inside this container, so it must stay

      // displayed even when collapsed — only its own row is flattened.

      const collapsed = drawingSubtoolbarCollapsed;

      const rowHeight = collapsed ? 0 : subRowHeight;



      drawingTools.setAttribute('data-collapsed', collapsed ? 'true' : 'false');

      drawingTools.style.setProperty('display', 'flex', 'important');

      drawingTools.style.removeProperty('visibility');

      drawingTools.style.removeProperty('pointer-events');

      drawingTools.style.setProperty('position', 'fixed', 'important');

      drawingTools.style.setProperty('top', `${subtoolbarTop}px`, 'important');

      drawingTools.style.setProperty('left', `${sidebarW}px`, 'important');

      drawingTools.style.removeProperty('right');

      drawingTools.style.setProperty('width', collapsed ? '0' : 'max-content', 'important');

      drawingTools.style.setProperty('max-width', `calc(100% - ${sidebarW}px)`, 'important');

      drawingTools.style.setProperty('height', `${rowHeight}px`, 'important');

      drawingTools.style.setProperty('min-height', `${rowHeight}px`, 'important');

      drawingTools.style.setProperty('max-height', `${rowHeight}px`, 'important');

      drawingTools.style.setProperty('margin', '0', 'important');

      drawingTools.style.setProperty('margin-top', '0', 'important');

      drawingTools.style.setProperty('padding-top', '0', 'important');

      drawingTools.style.setProperty('border-top', 'none', 'important');

      drawingTools.style.setProperty('transform', 'none', 'important');

      drawingTools.style.setProperty('z-index', '50', 'important');

    };



    let drawingSurfaceMotion = null;

    let pendingDrawingIntro = false;

    let toolbarBeforeLayout = null;

    const captureToolbarPositions = () => new Map(

      [...document.querySelectorAll('#chartcontrols > .am5stock')]

        .filter(node => node.getBoundingClientRect().width > 0)

        .map(node => [node, node.getBoundingClientRect().left]),

    );

    const animateToolbarPositions = () => {

      const previous = toolbarBeforeLayout;

      toolbarBeforeLayout = null;

      if (!previous || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      previous.forEach((left, button) => {

        if (!button.isConnected || !button.getBoundingClientRect().width) return;

        const offset = left - button.getBoundingClientRect().left;

        if (Math.abs(offset) < 1) return;

        // Move only icon/label content, so dropdown containing blocks stay stable.

        [...button.children].filter(child => !child.classList.contains('am5stock-control-list-container'))

          .forEach(child => child.animate([

            { translate: `${offset}px 0` }, { translate: '0px 0' },

          ], { duration: 240, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }));

      });

    };

    const animateDrawingSurface = (closing, done) => {

      const surface = drawingControl.getPrivate('toolsContainer');

      const sidebar = getDrawingSidebarPanel();

      if (!surface || !sidebar || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

        done();

        return;

      }

      drawingSurfaceMotion?.cancel();

      const left = parseFloat(getComputedStyle(surface).left) || 0;

      const top = parseFloat(getComputedStyle(surface).top) || 0;

      const distance = left + surface.offsetWidth;

      const sidebarWidth = sidebar.offsetWidth;

      sidebar.style.setProperty('left', `${-left}px`, 'important');

      sidebar.style.setProperty('top', `${-top}px`, 'important');

      // Two compositor timelines: sidebar enters first, then the row. The

      // sidebar counter-translation holds it still while its parent row moves.

      const rowFrames = [

        { translate: `${-distance}px 0`, offset: 0 },

        { translate: `${-distance}px 0`, offset: 0.5 },

        { translate: '0px 0', offset: 1 },

      ];

      const sidebarFrames = [

        { translate: `${distance - sidebarWidth}px 0`, offset: 0 },

        { translate: `${distance}px 0`, offset: 0.5 },

        { translate: '0px 0', offset: 1 },

      ];

      const options = { duration: 400, easing: 'linear', fill: 'both', direction: closing ? 'reverse' : 'normal' };

      const curve = 'cubic-bezier(0.22, 0.61, 0.36, 1)';

      rowFrames.forEach(frame => { frame.easing = curve; });

      sidebarFrames.forEach(frame => { frame.easing = curve; });

      const rowMotion = surface.animate(rowFrames, options);

      const sidebarMotion = sidebar.animate(sidebarFrames, options);

      const motion = { cancel: () => { rowMotion.cancel(); sidebarMotion.cancel(); } };

      drawingSurfaceMotion = motion;

      rowMotion.onfinish = () => {

        if (drawingSurfaceMotion !== motion) return;

        if (closing) surface.style.setProperty('display', 'none', 'important');

        motion.cancel();

        drawingSurfaceMotion = null;

        sidebar.style.setProperty('left', '0', 'important');

        sidebar.style.setProperty('top', '0', 'important');

        done();

      };

    };

    root.addDisposer(new am5.Disposer(() => drawingSurfaceMotion?.cancel()));



    const closeAllDrawPanels = (finish = false) => {

      const pane = document.querySelector('.chart-con');

      if (finish !== true && pane?.getAttribute('data-drawing-open') === 'true' &&

          !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {

        if (pane.getAttribute('data-drawing-anim') === 'close') return;

        if (drawingOpenAnimTimer) window.clearTimeout(drawingOpenAnimTimer);

        pane.setAttribute('data-drawing-anim', 'close');

        animateDrawingSurface(true, () => closeAllDrawPanels(true));

        return;

      }

      if (drawingOpenAnimTimer) {

        window.clearTimeout(drawingOpenAnimTimer);

        drawingOpenAnimTimer = null;

      }

      toolbarBeforeLayout = captureToolbarPositions();

      pendingDrawingIntro = false;

      drawingSurfaceMotion?.cancel();

      drawingSurfaceMotion = null;

      // Hide the whole surface before removing its animation to avoid a final flash.

      const toolsSurface = drawingControl.getPrivate('toolsContainer');

      if (toolsSurface) toolsSurface.style.display = 'none';

      document.querySelector('.chart-con')?.removeAttribute('data-drawing-anim');



      drawingControl.getPrivate('toolControl')?.set('active', false);

      if (drawingControl.get('active')) {

        drawingControl.set('active', false);

      }

      document

        .querySelectorAll('.am5stock-control-drawing-tools .am5stock-control-list-container')

        .forEach((el) => {

          el.style.display = 'none';

        });

      document.querySelector('.chart-con')?.setAttribute('data-drawing-open', 'false');

      document.querySelector('.chart-con')?.setAttribute('data-drawing-toolbar', 'false');

      document.querySelector('.chart-con')?.setAttribute('data-drawing-subtoolbar-collapsed', 'false');

      document.getElementById('chartcontrols')?.style.removeProperty('padding-left');

      clearDrawingSubtoolbarLayout(document.querySelector('.am5stock-control-drawing-tools'));

      drawingSubtoolbarCollapsed = false;

      activeDrawingSidebarToolId = '';

      document.querySelectorAll('.draw-sidebar-tool-active').forEach((el) => {

        el.classList.remove('draw-sidebar-tool-active');

      });

      document.querySelector('.chart-con')?.closest('.chart-box')?.setAttribute('data-drawing-sidebar-open', 'false');

      document.querySelector('.chart-con')?.style.removeProperty('--draw-sidebar-width');

      document.querySelector('.chart-con')?.style.removeProperty('--draw-close-height');

      document.querySelector('.chart-con')?.style.removeProperty('--draw-subtoolbar-top');

      wasDrawingControlActive = false;

      scheduleDrawingSidebarSyncRef();

    };



    const drawingHistoryControl = (label, path) => {

      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

      icon.setAttribute('viewBox', '0 0 24 24');

      icon.setAttribute('width', '30');

      icon.setAttribute('height', '30');

      icon.setAttribute('aria-hidden', 'true');

      icon.innerHTML = `<path d="${path}" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>`;

      const control = am5stock.StockControl.new(root, {

        stockChart, name: '', description: chartText(label, language), icon, togglable: false, visible: false,

      });

      const button = control.getPrivate('button');

      button.classList.add('chart-drawing-history-action');

      button.setAttribute('aria-label', chartText(label, language));

      button.setAttribute('role', 'button');

      return control;

    };

    const undoDrawingControl = drawingHistoryControl('Undo drawing', 'M9 5 4 10l5 5M4 10h9a6 6 0 0 1 6 6v3');

    const redoDrawingControl = drawingHistoryControl('Redo drawing', 'm15 5 5 5-5 5m5-5h-9a6 6 0 0 0-6 6v3');

    const drawingNotice = document.createElement('div');
    drawingNotice.setAttribute('role', 'status');
    drawingNotice.setAttribute('data-drawing-notice', 'true');
    Object.assign(drawingNotice.style, {position:'absolute', left:'50%', bottom:'40px', transform:'translateX(-50%)', padding:'7px 12px', background:'#252a40', color:'#fff', border:'1px solid #52596e', borderRadius:'4px', zIndex:'20', pointerEvents:'none', display:'none', fontSize:'11px'});
    Object.assign(drawingNotice.style, {bottom:'56px', padding:'9px 14px', background:'rgba(37,42,64,0.96)', border:'1px solid rgba(164,177,210,0.22)', borderRadius:'8px', boxShadow:'0 4px 16px rgba(0,0,0,0.22)', lineHeight:'16px', fontWeight:'500', whiteSpace:'nowrap', alignItems:'center', gap:'8px', maxWidth:'calc(100% - 32px)'});
    Object.assign(drawingNotice.style, {
      background: theme === 'light' ? '#fcfcfd' : 'rgba(37,42,64,0.96)',
      color: theme === 'light' ? '#374151' : '#ffffff',
      borderColor: theme === 'light' ? '#d5deeb' : 'rgba(164,177,210,0.22)',
      boxShadow: theme === 'light' ? '0 4px 12px rgba(40,55,80,0.12)' : '0 4px 16px rgba(0,0,0,0.22)',
    });
    drawingNotice.style.setProperty('padding', '9px 14px', 'important');
    drawingNotice.style.setProperty('min-height', '34px', 'important');
    drawingNotice.style.setProperty('box-sizing', 'border-box', 'important');
    const noticeIcon = document.createElement('span');
    noticeIcon.setAttribute('aria-hidden', 'true');
    Object.assign(noticeIcon.style, {fontSize:'17px', color:theme === 'light' ? '#60738e' : '#aebce0', lineHeight:'16px'});
    const noticeText = document.createElement('span');
    drawingNotice.append(noticeIcon, noticeText);
    root.dom.appendChild(drawingNotice);
    let drawingNoticeTimer;
    root.addDisposer(new am5.Disposer(() => { clearTimeout(drawingNoticeTimer); drawingNotice.remove(); }));
    const drawingHistory = createDrawingHistory({
      onRestore: action => {
        noticeIcon.textContent = action === 'undo' ? '↶' : '↷';
        noticeText.textContent = action === 'undo' ? 'Drawing change undone' : 'Drawing change redone';
        drawingNotice.style.display = 'flex';
        clearTimeout(drawingNoticeTimer);
        drawingNoticeTimer = setTimeout(() => { drawingNotice.style.display = 'none'; }, 1800);
      },

      stockChart,

      onComplete: () => {

        // Finish amCharts' selection frame before clearing the completed tool.

        const clearCompletedTool = () => {

          drawingControl.setRaw('tool', undefined);
          drawingControl._setTool(undefined);

          stockChart.panels.each(panel => panel.drawings.each(series => {

            series.disableDrawing();

          }));

          stockChart.unselectDrawings();

          const toolControl = drawingControl.getPrivate('toolControl');

          if (toolControl) toolControl.setTool('Select');

          // Preserve the last tool's property controls; only disarm drawing.

          drawingControl.getPrivate('selectControl')?.set('active', false);

          drawingControl.getPrivate('eraserControl')?.set('active', false);

          stockChart.set('drawingSelectionEnabled', true);
          stockChart.setPrivate('drawingSelectionEnabled', true);
          setDrawingSidebarActiveTool('');

        };

        clearCompletedTool();

        root.events.once('frameended', clearCompletedTool);

      },

      onChange: ({ canUndo, canRedo }) => {

        [[undoDrawingControl, canUndo], [redoDrawingControl, canRedo]].forEach(([control, enabled]) => {

          const button = control.getPrivate('button');

          button.setAttribute('aria-disabled', String(!enabled));

          button.tabIndex = enabled ? 0 : -1;

        });

      },

    });

    undoDrawingControl.events.on('click', () => drawingHistory.undo());

    redoDrawingControl.events.on('click', () => drawingHistory.redo());

    root.addDisposer(new am5.Disposer(() => drawingHistory.dispose()));



    const resetControl = am5stock.ResetControl.new(root, { stockChart });

    // Reset removes indicators, but an expanded indicator leaves the price panel hidden.

    resetControl.events.on('click', () => {

      closeAllDrawPanels(true);

      drawingHistory.reset();

      if (!mainPanel.isVisible()) mainPanel.expand();

      stockChart._updateControls();

    });



    const settingsControl = am5stock.SettingsControl.new(root, {

      stockChart, autoSave: true, exclude: ['y-scale'],

    });

    settingsControl.getPrivate('button').classList.add('chart-settings-control');



    // Stock toolbar

    const stockToolbar = am5stock.StockToolbar.new(root, {
      focusable: true,

      container: document.getElementById('chartcontrols'),

      stockChart: stockChart,

      controls: [

        symbolSearchList,

        seriesSwitcher,

        intervalSwitcher,

        am5stock.IndicatorControl.new(root, {

          stockChart: stockChart,

          legend: valueLegend,

          searchable: true,

          maxSearchItems: 1000,

          searchCallback: function (query) {

            const needle = String(query || '').trim().toLowerCase();

            const items = this.get('items') || [];

            if (!needle) return items;

            return items.filter((item) => {

              const label = (item.label || item.id || '').toString().toLowerCase();

              return label.includes(needle);

            });

          },

        }),

        drawingControl,

        settingsControl,

        resetControl,

        undoDrawingControl,

        redoDrawingControl,

      ],

    });



    const toolbarElement = document.getElementById('chartcontrols');
    const toolbarSpace = event => {
      if (event.key === ' ' && event.target.matches('.am5stock-control-button[role="button"], .am5stock-list-item')) {
        event.preventDefault(); event.stopPropagation(); event.target.click();
      }
      if (['ArrowDown', 'ArrowUp'].includes(event.key) && !event.target.matches('input, textarea')) event.preventDefault();
    };
    toolbarElement.addEventListener('keydown', toolbarSpace);
    root.addDisposer(new am5.Disposer(() => toolbarElement.removeEventListener('keydown', toolbarSpace)));

    root.addDisposer(root.events.once('frameended', () => configureDrawingActions(drawingControl, stockToolbar)));
    root.addDisposer(stockChart.events.on('drawingselected', e => {
      // Selecting an existing drawing is also an entry point into its controls.
      drawingControl.set('active', true);
      setDrawingSubtoolbarCollapsed(false);
      drawingControl.getPrivate('toolControl')?.set('active', true);
      setDrawingSidebarActiveTool(drawingControl._getSeriesTool(e.series));
      scheduleDrawingSidebarSyncRef();
    }));
    root.addDisposer(stockChart.events.on('drawingremoved', () => setDrawingSidebarActiveTool('')));

    // Focus only when opening a searchable popup, after the opening click ends.

    stockToolbar.get('controls').forEach(control => {

      if (control !== symbolSearchList && !control.isType('IndicatorControl')) return;

      const dropdown = control.getPrivate('dropdown');

      if (!dropdown) return;

      let focusFrame;

      const cancelFocus = () => cancelAnimationFrame(focusFrame);

      const opened = dropdown.events.on('opened', () => {

        cancelFocus();

        focusFrame = requestAnimationFrame(() => {

          if (!root.isDisposed() && dropdown.isOpen()) {

            dropdown.getPrivate('search')?.querySelector('input')?.focus({ preventScroll: true });

          }

        });

      });

      const closed = dropdown.events.on('closed', cancelFocus);

      root.addDisposer(new am5.Disposer(() => { cancelFocus(); opened.dispose(); closed.dispose(); }));

    });



    // Harden every StockLegend (overlay + panel indicators like RSI) so cards stay solid.

    const hardenStockLegend = (legend) => {

      if (!legend || !legend.itemContainers) return;
      configureStockLegendCleanup(legend);

      // Keep indicator controls in the separator, without an overlay card.

      const owner = stockChart.panels.values.find(p => p.topPlotContainer === legend.parent || p.plotContainer === legend.parent);

      if (owner && owner !== mainPanel) {
        owner.topAxesContainer.setAll({ height: 28, minHeight: 28, layout: undefined,
          paddingTop: 0, paddingBottom: 0 });
        owner.topAxesContainer.children.push(legend);
        legend.setAll({ isMeasured: false, height: 28 });

        legend.setAll({ y: 0, centerY: 0, width: undefined, paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0 });

        legend.itemContainers.template.setAll({ y: 0, centerY: 0, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, height: 28 });

        legend.itemContainers.each(item => item.setAll({ y: 0, centerY: 0, marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0, height: 28 }));

        owner.set('paddingTop', 0);

      }

      legend.data.values.forEach(series => {

        for (const key of ['legendValueText', 'legendRangeValueText']) {

          const text = series.get(key);

          if (typeof text === 'string') series.set(key, text.replace(/formatNumber\([^)]*\)/g, "formatNumber('#,###.########')"));

        }

      });

      legend.labels.template.setAll({ fontSize: 10, y: 14, centerY: am5.p50, paddingTop: 0, paddingBottom: 0 });

      legend.valueLabels.template.setAll({ fontSize: 10, y: 14, centerY: am5.p50, paddingTop: 0, paddingBottom: 0 });

      legend.labels.each(label => label.setAll({ fontSize: 10, y: 14, centerY: am5.p50, paddingTop: 0, paddingBottom: 0 }));

      legend.valueLabels.each(label => label.setAll({ fontSize: 10, y: 14, centerY: am5.p50, paddingTop: 0, paddingBottom: 0 }));

      const placeSettings = button => {

        button.setAll({ width: 22, height: 22, y: 14, centerY: am5.p50, paddingTop: 2, paddingBottom: 2, paddingLeft: 2, paddingRight: 2 });

        button.get('icon')?.setAll({ scale: 0.75, y: am5.p50, centerY: am5.p50 });

        const item = button.dataItem;

        const container = item?.get('itemContainer');

        const value = item?.get('label');

        if (container && value) container.children.moveValue(button, 0);

      };

      legend.settingsButtons.template.setAll({ width: 22, height: 22, paddingTop: 2, paddingBottom: 2, paddingLeft: 2, paddingRight: 2 });

      legend.settingsButtons.each(button => { button.setAll({ width: 22, height: 22, paddingTop: 2, paddingBottom: 2, paddingLeft: 2, paddingRight: 2 }); button.get('icon')?.setAll({ scale: 0.75, y: am5.p50, centerY: am5.p50 }); placeSettings(button); });

      if (!legend.__settingsBeforeValues) {

        legend.__settingsBeforeValues = true;

        legend.settingsButtons.events.on('push', event => {

          legend.setTimeout(() => { if (!event.newValue.isDisposed()) placeSettings(event.newValue); }, 0);

        });

      }

      if (legend.__synchronizedCards) return;

      legend.__synchronizedCards = true;

      // Canvas inline value colors share one label: outline only white glyphs,

      // rather than applying a shadow to the entire multicolored label.

      if (theme === 'light') {

        root.dom.querySelectorAll('canvas').forEach(canvas => {

          const context = canvas.getContext('2d');

          if (!context || context.__whiteTextOutline) return;

          context.__whiteTextOutline = true;

          const original = context.fillText;

          context.fillText = function (...args) {

            const fill = String(this.fillStyle).toLowerCase().replace(/\s/g, '');

            if (fill === '#ffffff' || fill === '#fff' || fill === 'white' || fill === 'rgb(255,255,255)') {

              this.save();

              this.strokeStyle = '#526176';

              this.lineWidth = 1.5;

              this.lineJoin = 'round';

              this.strokeText(...args);

              this.restore();

            }

            return original.apply(this, args);

          };

          root.addDisposer(new am5.Disposer(() => { context.fillText = original; delete context.__whiteTextOutline; }));

        });

      }

      const styleCloseButton = (button) => {

        button.setAll({ width: 24, height: 24, centerY: am5.p50, paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0 });

        const background = button.get('background');

        background?.setAll({ fill: am5.color(chartColors.text), fillOpacity: 0, strokeOpacity: 0, cornerRadiusTL: 4, cornerRadiusTR: 4, cornerRadiusBL: 4, cornerRadiusBR: 4, stateAnimationDuration: 0 });

        background?.states.create('hover', { fillOpacity: 0.12, strokeOpacity: 0 });

        background?.states.create('down', { fillOpacity: 0.18, strokeOpacity: 0 });

        button.get('icon')?.setAll({

          stroke: am5.color(chartColors.text), strokeOpacity: 0.8,

          strokeWidth: 1.3, fillOpacity: 0, centerX: am5.p50, centerY: am5.p50, x: am5.p50, y: am5.p50,

          draw: (display) => {

            display.moveTo(-4, -4); display.lineTo(4, 4);

            display.moveTo(-4, 4); display.lineTo(4, -4);

          },

        });

        button.get('icon')?.states.create('hover', { strokeOpacity: 1, fillOpacity: 0 });

      };

      legend.closeButtons.template.setup = styleCloseButton;

      legend.closeButtons.each(styleCloseButton);

      // Let values use their natural width; empty values must not leave a gap.

      legend.valueLabels.template.setAll({ minWidth: 0, textAlign: 'right' });

      legend.valueLabels.each((label) => label.setAll({ minWidth: 0, textAlign: 'right' }));

      legend.itemContainers.template.setAll({ opacity: 1, stateAnimationDuration: 0 });

      const setupCard = (target) => {

        if (target.__synchronizedBackground) return;

        target.__synchronizedBackground = true;

        target.setAll({ opacity: 1, stateAnimationDuration: 0 });

        const previousBackground = target.get('background');

        target.set(

          'background',

          am5.RoundedRectangle.new(root, {

            fill: am5.color(chartColors.panel),

            fillOpacity: 0,

            cornerRadiusTL: 4,

            cornerRadiusTR: 4,

            cornerRadiusBL: 4,

            cornerRadiusBR: 4,

            shadowBlur: 0,

            shadowOpacity: 0,

            shadowOffsetX: 0,

            shadowOffsetY: 0,

            stateAnimationDuration: 0,

          }),

        );

        // Replaced backgrounds are not automatically disposed by amCharts.
        previousBackground?.dispose();

        // Values and buttons move before the container's cached bounds settle.

        // Size from the current children so the card follows that same layout.

        const background = target.get('background');

        const contentWidth = () => {

          let right = 0;

          target.children.each(child => {

            if (child === background || !child.isVisible()) return;

            right = Math.max(right, child.x() + child.localBounds().right);

          });

          return right + 4;

        };

        background.adapters.add('width', () => contentWidth());

        const syncBackground = () => {

          const width = contentWidth();

          if (background.getRaw('width') !== width) background.set('width', width);

        };

        const watchChild = child => {

          child.events.on('positionchanged', syncBackground);

          child.events.on('boundschanged', syncBackground);

          child.on('visible', syncBackground);

        };

        target.children.each(watchChild);

        target.children.events.on('push', event => { watchChild(event.newValue); syncBackground(); });

        target.events.on('boundschanged', syncBackground);

      };

      legend.itemContainers.template.setup = setupCard;

      legend.itemContainers.each(setupCard);

    };

    // A single stroke keeps pixel position and dash phase identical across panels.

    let crosshairTop = 0, crosshairBottom = 0;

    let crosshairLeft = 0, crosshairRight = 0, crosshairY = 0;

    const unifiedCrosshair = root.container.children.push(am5.Graphics.new(root, {

      isMeasured: false, interactive: false, visible: false,

      stroke: am5.color(chartColors.muted), strokeWidth: 1, strokeOpacity: 1,

      strokeDasharray: [2, 2],

      draw: display => {

        display.moveTo(0, crosshairTop); display.lineTo(0, crosshairBottom);

        display.moveTo(crosshairLeft, crosshairY); display.lineTo(crosshairRight, crosshairY);

      },

    }));

    unifiedCrosshair.set('userData', 'chart-crosshair');
    root.addDisposer(stockChart.onPrivate('drawingHovered', hovered => {
      if (hovered) unifiedCrosshair.set('visible', false);
    }));

    const moveUnifiedCrosshair = event => {
      if (stockChart.getPrivate('drawingHovered') || stockChart.getPrivate('settingsModal')?.isOpen()) {
        unifiedCrosshair.set('visible', false);
        return;
      }

      const rect = root.dom.getBoundingClientRect();

      const x = (event.clientX - rect.left) * root.width() / rect.width;

      const y = (event.clientY - rect.top) * root.height() / rect.height;

      const panels = stockChart.panels.values.filter(panel => panel.isVisible() && !panel.isDisposed());

      if (!panels.length) return;

      const bounds = panels.map(panel => {

        const plot = panel.plotContainer;

        const p = root.container.toLocal(plot.toGlobal({ x: 0, y: 0 }));

        return { x: p.x, y: p.y, right: p.x + plot.width(), bottom: p.y + plot.height() };

      });

      crosshairTop = Math.min(...bounds.map(b => b.y));

      crosshairBottom = Math.max(...bounds.map(b => b.bottom));

      const inside = x >= Math.max(...bounds.map(b => b.x)) && x <= Math.min(...bounds.map(b => b.right))

        && y >= crosshairTop && y <= crosshairBottom;

      crosshairLeft = Math.max(...bounds.map(b => b.x)) - x;

      crosshairRight = Math.min(...bounds.map(b => b.right)) - x;

      crosshairY = y;

      unifiedCrosshair.setAll({ x, visible: inside });

      // Graphics caches its drawing commands. Updating only x/visible or calling

      // markDirty does not redraw geometry captured by the draw callback.

      unifiedCrosshair.set('draw', display => {

        display.moveTo(0, crosshairTop); display.lineTo(0, crosshairBottom);

        display.moveTo(crosshairLeft, crosshairY); display.lineTo(crosshairRight, crosshairY);

      });

    };

    const hideUnifiedCrosshair = () => unifiedCrosshair.set('visible', false);
    const crosshairModal = stockChart.getPrivate('settingsModal');
    if (crosshairModal) {
      root.addDisposer(crosshairModal.events.on('opened', hideUnifiedCrosshair));
    }


    root.dom.addEventListener('pointermove', moveUnifiedCrosshair, { passive: true });

    root.dom.addEventListener('pointerleave', hideUnifiedCrosshair);

    root.addDisposer(new am5.Disposer(() => {

      root.dom.removeEventListener('pointermove', moveUnifiedCrosshair);

      root.dom.removeEventListener('pointerleave', hideUnifiedCrosshair);

    }));

    const configurePanelControls = (panel) => {

      if (panel.__controlHintsReady) return;

      panel.__controlHintsReady = true;

      // Indicator panels are pushed before their cursor/axes are constructed.

      // Observe cursor assignment instead of configuring an unfinished panel once.

      const configureCursor = cursor => {

        if (!cursor) return;

        cursor.setAll({ xAxis: undefined, yAxis: undefined, snapToSeries: [], behavior: 'none' });

        cursor.lineX.setAll({ visible: true, forceHidden: false, stroke: am5.color(chartColors.muted), strokeOpacity: 1 });

        cursor.lineY.setAll({ visible: true, forceHidden: false, stroke: am5.color(chartColors.muted), strokeOpacity: 1 });

        cursor.lineX.set('forceHidden', true);

        cursor.lineY.set('forceHidden', true);

        panel.plotContainer.get('background')?.setAll({ interactive: true, cursorOverStyle: 'crosshair' });

        [...panel.xAxes.values, ...panel.yAxes.values].forEach(axis => {

          axis.get('tooltip')?.set('animationDuration', 0);

        });

      };

      configureCursor(panel.get('cursor'));

      // Release this listener with its panel, not only when the whole chart closes.
      panel.addDisposer(panel.on('cursor', configureCursor));

      const controls = panel.panelControls;

      controls.setAll({ scale: 0.75, opacity: 0.65, layout: undefined, height: 28 });

      const controlButtons = [controls.upButton, controls.downButton, controls.expandButton, controls.closeButton];
      const alignPanelControls = () => {
        if (!controls.parent || panel.isDisposed()) return;
        // Anchor to the plot edge, not the full header (which includes the price axis).
        // Explicit positioning avoids a stale percentage pivot when a fourth button appears.
        const edge = controls.parent.toLocal(panel.plotContainer.toGlobal({ x: panel.plotContainer.width(), y: 0 })).x;
        const width = controls.get('width', 0) * controls.get('scale', 1);
        controls.setAll({ x: Math.max(0, edge - width - 6), centerX: 0 });
      };
      // StockChart toggles private visibility during reorder. Use explicit cells:
      // the automatic layout can otherwise retain a newly visible arrow at x=0.
      const arrangeControlButtons = () => {
        let x = 0;
        controlButtons.forEach(button => {
          if (button.getPrivate('visible') === false || button.get('forceHidden')) return;
          button.set('x', x);
          x += 31;
        });
        controls.set('width', Math.max(0, x - 3) + controls.get('paddingRight', 0));
        alignPanelControls();
      };

      controls.states.create('hover', { opacity: 0.95 });

      if (panel !== mainPanel) {

        // Share the existing indicator header without consuming plot space.

        panel.topAxesContainer.children.moveValue(controls);

        controls.setAll({ isMeasured: false, centerX: 0,

          y: 14, centerY: am5.p50, paddingTop: 0, paddingBottom: 0, paddingRight: 6 });

      }

      // Preserve the compact footprint, but use stronger vector strokes so

      // scaling does not reduce the controls to faint subpixel hairlines.

      const drawPanelIcon = (kind) => display => {

        display.drawCircle(0, 0, 10);

        if (kind === 'close') {

          display.moveTo(-3.5, -3.5); display.lineTo(3.5, 3.5);

          display.moveTo(3.5, -3.5); display.lineTo(-3.5, 3.5);

        } else {

          const direction = kind === 'up' ? -1 : 1;

          display.moveTo(-4, -direction * 1.5);

          display.lineTo(0, direction * 2.5);

          display.lineTo(4, -direction * 1.5);

        }

      };

      [controls.upButton, controls.downButton, controls.expandButton, controls.closeButton].forEach(button => {

        // Fixed cells keep the negative-coordinate circle glyphs from overlapping.
        button.setAll({ width: 28, height: 28, scale: 1, marginLeft: 0, layout: undefined,
          paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
          centerX: 0, centerY: 0 });

        const glyph = button.get('icon');

        glyph.setAll({ x: 14, y: 14, centerX: am5.p50, centerY: am5.p50 });

        glyph.setAll({ stroke: am5.color(chartColors.text), strokeOpacity: 0.85,

          strokeWidth: 1.2, fillOpacity: 0, lineJoin: 'round', lineCap: 'round' });

        glyph.states.create('hover', { strokeOpacity: 1, strokeWidth: 1.4 });

        button.events.on('pointerover', () => glyph.states.apply('hover'));

        button.events.on('pointerout', () => glyph.states.apply('default'));

        panel.addDisposer(button.onPrivate('visible', arrangeControlButtons));

      });

      arrangeControlButtons();
      panel.addDisposer(panel.plotContainer.events.on('boundschanged', alignPanelControls));
      panel.addDisposer(panel.topAxesContainer.events.on('boundschanged', alignPanelControls));

      controls.upButton.get('icon').set('draw', drawPanelIcon('up'));

      controls.downButton.get('icon').set('draw', drawPanelIcon('down'));

      controls.closeButton.get('icon').set('draw', drawPanelIcon('close'));



      const addHint = (button, text) => {

        const hint = am5.Tooltip.new(root, { pointerOrientation: 'up', animationDuration: 0, stateAnimationDuration: 0, getFillFromSprite: false, getStrokeFromSprite: false, getLabelFillFromSprite: false });

        hint.get('background').setAll({ fill: am5.color(chartColors.panel), stroke: am5.color(chartColors.muted), strokeOpacity: 0.3 });

        hint.label.setAll({ fill: am5.color(chartColors.text), fontSize: 11 });

        button.setAll({ tooltip: hint, tooltipText: text, ariaLabel: text, showTooltipOn: 'hover', tooltipPosition: 'fixed', tooltipX: am5.p50, tooltipY: am5.p100 });

        button.events.on('pointerout', () => hint.hide(0));

        button.events.on('pointerdown', () => hint.hide(0));

      };

      addHint(controls.upButton, 'Move panel up');

      addHint(controls.downButton, 'Move panel down');

      addHint(controls.closeButton, 'Close panel');

      addHint(controls.expandButton, 'Expand panel');

      const icon = controls.expandButton.get('icon');

      // Keep identical bounds in both states so changing the glyph cannot

      // move the right-aligned control group off the panel.

      const drawExpandIcon = (restore) => (display) => {

        display.drawCircle(0, 0, 10);

        if (restore) {

          display.moveTo(-6, -6); display.lineTo(-2, -2);

          display.moveTo(-6, -2); display.lineTo(-2, -2); display.lineTo(-2, -6);

          display.moveTo(6, 6); display.lineTo(2, 2);

          display.moveTo(6, 2); display.lineTo(2, 2); display.lineTo(2, 6);

        } else {

          display.moveTo(-2, -2); display.lineTo(-6, -6);

          display.moveTo(-6, -2); display.lineTo(-6, -6); display.lineTo(-2, -6);

          display.moveTo(2, 2); display.lineTo(6, 6);

          display.moveTo(6, 2); display.lineTo(6, 6); display.lineTo(2, 6);

        }

      };

      icon.set('draw', drawExpandIcon(false));

      const clearPanelHints = () => {

        stockChart.panels.each((p) => {

          const c = p.panelControls;

          [c.upButton, c.downButton, c.expandButton, c.closeButton].forEach((b) => { b.get('tooltip')?.hide(0); b.unhover(); });

        });

      };

      panel.events.on('expanded', () => {

        clearPanelHints();

        controls.expandButton.setAll({ tooltipText: 'Restore panel', ariaLabel: 'Restore panel' });

        icon.set('draw', drawExpandIcon(true));

      });

      panel.events.on('collapsed', () => {

        clearPanelHints();

        controls.expandButton.setAll({ tooltipText: 'Expand panel', ariaLabel: 'Expand panel' });

        icon.set('draw', drawExpandIcon(false));

        panel.setTimeout(() => {

          if (stockChart.isDisposed()) return;

          stockChart._updateControls();

          stockChart.panels.each((p) => {

            p.panelControls.show(0);

            p.panelControls.markDirtySize();

          });

        }, 0);

      });

    };

    const panelsContainer = stockChart.panelsContainer;

    const panelWeights = new WeakMap();



    const singlePanelHeights = new WeakMap();

    const formatChartDate = (value, format) => root.dateFormatter.format(value, format);
    const syncTimeAxis = () => {

      if (stockChart.isDisposed()) return;

      const visible = stockChart.panels.values

        .filter(panel => !panel.isDisposed() && panel.isVisible())

        .sort((a, b) => panelsContainer.children.indexOf(a) - panelsContainer.children.indexOf(b));

      const bottom = visible[visible.length - 1];

      stockChart.panels.each(panel => {
        if (panel.isDisposed()) return;
        panel.xAxes.each(axis => {
        const renderer = axis.get('renderer');
        if (axis.isDisposed() || !renderer || renderer.isDisposed() || renderer.labels.template.isDisposed()) return;

        configureChartTimeAxis(axis, formatChartDate);

        renderer.set('pan', 'zoom');
        renderer.labels.template.set('fontSize', 10);
        const axisTip = axis.get('tooltip');
        if (axisTip) {
          axisTip.setAll({ getFillFromSprite: false, getStrokeFromSprite: false, autoTextColor: false });
          axisTip.label.setAll({ fontSize: 10, fill: am5.color(chartColors.text) });
          axisTip.get('background').setAll({ fill: am5.color(chartColors.panel), fillOpacity: 0.98,
            stroke: am5.color(chartColors.muted), strokeOpacity: 0.25,
            cornerRadiusTL: 4, cornerRadiusTR: 4, cornerRadiusBL: 4, cornerRadiusBR: 4 });
        }


        renderer.labels.template.set('forceHidden', panel !== bottom);

        renderer.labels.each(label => { if (!label.isDisposed()) label.set('forceHidden', panel !== bottom); });

        axis.set('height', panel === bottom ? undefined : 0);

        axis.get('tooltip')?.set('forceHidden', panel !== bottom);

        });
      });

      const available = panelsContainer.innerHeight();

      if (!Number.isFinite(available) || available <= 0) return;

      const allocations = visible.map(panel => {

        if (visible.length > 1 && singlePanelHeights.has(panel)) {

          panel.set('height', singlePanelHeights.get(panel));

          singlePanelHeights.delete(panel);

        }

        if (panel !== mainPanel) panel.yAxes.each(axis => {

          const format = indicatorNumberFormat(axis.get('numberFormat'));

          axis.setAll({ numberFormat: format, tooltipNumberFormat: format });

        });

        const minimum = minimumPanelHeight({

          isPricePanel: panel === mainPanel,

          header: panel.topAxesContainer.height(),

          footer: panel === bottom ? panel.bottomAxesContainer.height() : 0,

          padding: panel.get('paddingTop', 0) + panel.get('paddingBottom', 0),

        });

        // Final allocation below owns minHeight; avoid toggling it on every layout.

        const height = panel.get('height');

        if (height?.value) panelWeights.set(panel, height.value);

        return { minimum, weight: panelWeights.get(panel) || 1 };

      });

      const overheads = visible.map(panel => panel.topAxesContainer.height()

        + panel.bottomAxesContainer.height() + panel.get('paddingTop', 0) + panel.get('paddingBottom', 0));

      const plotSpace = Math.max(0, available - overheads.reduce((sum, h) => sum + h, 0));

      const weights = visible.map(panel => panel === mainPanel ? 2 : 1);

      const weightTotal = weights.reduce((sum, weight) => sum + weight, 0);

      const minimumTotal = allocations.reduce((sum, panel) => sum + panel.minimum, 0);

      const heights = minimumTotal <= available ? fitPanelHeights(available, allocations)

        : overheads.map((height, index) => height + plotSpace * weights[index] / weightTotal);

      visible.forEach((panel, index) => {

        panel.set('minHeight', 0);

        panel.set('height', visible.length === 1 ? available : heights[index]);

      });

      if (panelsContainer.get('verticalScrollbar')) panelsContainer.set('verticalScrollbar', undefined);

    };

    let panelLayoutFrame;

    const schedulePanelLayout = () => {

      cancelAnimationFrame(panelLayoutFrame);

      panelLayoutFrame = requestAnimationFrame(syncTimeAxis);

    };

    root.addDisposer(new am5.Disposer(() => cancelAnimationFrame(panelLayoutFrame)));

    panelsContainer.events.on('boundschanged', schedulePanelLayout);

    root.container.events.on('boundschanged', schedulePanelLayout);

    panelsContainer.onPrivate('height', schedulePanelLayout);

    stockChart.panels.events.onAll(schedulePanelLayout);

    const watchPanelLayout = panel => {
      configureStockAxisCleanup(stockChart, panel);

      panel.on('visible', schedulePanelLayout);

      panel.events.on('expanded', schedulePanelLayout);

      panel.events.on('collapsed', schedulePanelLayout);

      panel.events.on('moved', schedulePanelLayout);

      panel.on('height', schedulePanelLayout);

      panel.topAxesContainer.events.on('boundschanged', schedulePanelLayout);

      panel.bottomAxesContainer.events.on('boundschanged', schedulePanelLayout);

    };

    stockChart.panels.each(watchPanelLayout);

    stockChart.panels.events.on('push', event => watchPanelLayout(event.newValue));

    schedulePanelLayout();

    stockChart.panels.each(configurePanelControls);

    stockChart.panels.events.on('push', (event) => configurePanelControls(event.newValue));

    // Removing an indicator does not refresh the remaining panel's controls.

    stockChart.panels.events.onAll((event) => {

      if (event.type !== 'removeIndex' && event.type !== 'clear') return;

      if (stockChart.panels.length === 1) {

        const remaining = stockChart.panels.getIndex(0);

        if (!remaining.isVisible()) remaining.expand();

      }

      stockChart._updateControls();

    });

    hardenStockLegend(valueLegend);
    const overlayHost = document.createElement('div');
    overlayHost.className = 'desktop-toolbar-indicators';
    overlayHost.setAttribute('aria-label', 'Chart indicators');
    overlayHost.addEventListener('pointerdown', e => e.stopPropagation());
    overlayHost.addEventListener('click', e => e.stopPropagation());
    const indicatorToolbar = document.getElementById('chartcontrols');
    indicatorToolbar.appendChild(overlayHost);
    const colorPicker = indicatorToolbar.parentElement?.querySelector('.chart-color-picker');
    const reserveToolbarControls = () => {
      const width = colorPicker?.getBoundingClientRect().width || 0;
      indicatorToolbar.style.maxWidth = `calc(100% - ${Math.ceil(width + 8)}px)`;
    };
    const toolbarSpaceObserver = new ResizeObserver(reserveToolbarControls);
    if (colorPicker) toolbarSpaceObserver.observe(colorPicker);
    reserveToolbarControls();
    root.addDisposer(new am5.Disposer(() => {
      toolbarSpaceObserver.disconnect(); indicatorToolbar.style.removeProperty('max-width');
    }));
    root.addDisposer(new am5.Disposer(() => overlayHost.remove()));
    const inlineIndicators = document.createElement('div');
    inlineIndicators.className = 'toolbar-indicator-primary';
    const previousIndicator = document.createElement('button');
    const nextIndicator = document.createElement('button');
    previousIndicator.type = nextIndicator.type = 'button';
    previousIndicator.className = nextIndicator.className = 'indicator-scroll-button';
    previousIndicator.textContent = '‹'; nextIndicator.textContent = '›';
    previousIndicator.setAttribute('aria-label', 'Scroll indicators left');
    nextIndicator.setAttribute('aria-label', 'Scroll indicators right');
    previousIndicator.hidden = nextIndicator.hidden = true;
    previousIndicator.onclick = () => inlineIndicators.scrollBy({ left: -Math.max(160, inlineIndicators.clientWidth * 0.7), behavior: 'smooth' });
    nextIndicator.onclick = () => inlineIndicators.scrollBy({ left: Math.max(160, inlineIndicators.clientWidth * 0.7), behavior: 'smooth' });
    overlayHost.append(previousIndicator, inlineIndicators, nextIndicator);
    const indicatorChips = document.createElement('div');
    indicatorChips.className = 'desktop-toolbar-indicators indicator-overflow-chips';
    indicatorChips.setAttribute('aria-label', 'Indicator values');
    indicatorChips.hidden = true;
    indicatorChips.addEventListener('pointerdown', e => e.stopPropagation());
    indicatorChips.addEventListener('click', e => e.stopPropagation());
    indicatorToolbar.append(indicatorChips);
    root.addDisposer(new am5.Disposer(() => indicatorChips.remove()));
    const overlayRows = new Map();
    const legendText = label => label?.text?._getText?.() || '';
    const plainIndicatorText = label => legendText(label).replace(/\[[^\]]*\]/g, '');
    const syncOverlayRows = () => {
      // The first visible pane shares the bounded toolbar with overlay indicators.
      // This also covers a lower indicator temporarily expanded to fill the chart.
      const toolbarLegends = [];
      const firstPanel = stockChart.panelsContainer.children.values.find(child =>
        stockChart.panels.values.includes(child) && !child.isDisposed() && child.isVisible());
      stockChart.panels.each(panel => {
        if (panel === mainPanel || panel.isDisposed()) return;
        const inToolbar = panel === firstPanel;
        [...panel.topPlotContainer.children.values, ...panel.topAxesContainer.children.values].forEach(child => {
          if (!child.isType('StockLegend')) return;
          child.set('visible', !inToolbar);
          if (inToolbar) toolbarLegends.push(child);
        });
      });
      const toolbarItems = toolbarLegends.length ? toolbarLegends.flatMap(legend => legend.dataItems) : valueLegend.dataItems;
      const active = new Set(toolbarItems.filter(item => {
        const indicator = item.get('settingsButton')?.getPrivate('customData');
        return !item.isDisposed() && indicator && !indicator.isDisposed()
          && stockChart.indicators.values.includes(indicator);
      }));
      overlayRows.forEach((row, item) => {
        if (!active.has(item)) { row.element.remove(); overlayRows.delete(item); }
      });
      overlayHost.hidden = active.size === 0;
      active.forEach(item => {
        let row = overlayRows.get(item);
        if (!row) {
          const element = document.createElement('div');
          element.className = 'desktop-toolbar-indicator';
          const settings = document.createElement('button');
          settings.type = 'button';
          const settingsIcon = am5stock.StockIcons.getIcon('Settings');
          settingsIcon.setAttribute('aria-hidden', 'true');
          settingsIcon.setAttribute('class', 'indicator-settings-icon');
          settings.append(settingsIcon);
          settings.setAttribute('aria-label', 'Indicator settings');
          const name = document.createElement('span'); name.className = 'indicator-name';
          const values = document.createElement('span'); values.className = 'indicator-values';
          const remove = document.createElement('button');
          remove.type = 'button'; remove.textContent = '\u00d7';
          remove.setAttribute('aria-label', 'Delete indicator');
          settings.onclick = () => {
            const indicator = item.get('settingsButton')?.getPrivate('customData');
            const modal = stockChart.getPrivate('settingsModal');
            if (indicator) modal.openIndicator(indicator); else modal.openSeries(item.dataContext);
          };
          remove.onclick = () => {
            const indicator = item.get('settingsButton')?.getPrivate('customData');
            if (indicator) {
              indicator.dispose();
              valueLegend.data.removeValue(item.dataContext);
              syncOverlayRows();
            }
          };
          element.append(settings, name, values, remove);
          inlineIndicators.append(element);
          const slotCount = item.get('settingsButton')?.getPrivate('customData')?.isType('HeikinAshi') ? 4 : Math.max(1, (item.dataContext.get('legendValueText', '').match(/formatNumber\(/g) || []).length);
          values.style.setProperty('--indicator-value-slots', String(slotCount));
          for (let slot = 0; slot < slotCount; slot++) {
            const placeholder = document.createElement('span');
            placeholder.textContent = '—'; values.append(placeholder);
          }
          row = { element, name, values, last: '', slotCount }; overlayRows.set(item, row);
          // Start with the latest candle; cursor updates then supply the hovered values.
          const series = item.dataContext;
          const latest = series.dataItems?.[series.dataItems.length - 1];
          if (latest) series.updateLegendValue(latest);
        }
        const name = plainIndicatorText(item.get('label')) || item.dataContext.get('name') || 'Indicator';
        if (row.name.textContent !== name) { row.name.textContent = name; row.name.title = name; }
        if (!row.last) {
          const series = item.dataContext;
          const latest = series.dataItems?.[series.dataItems.length - 1];
          if (latest && Number.isFinite(latest.get('valueY'))) series.updateLegendValue(latest);
        }
        let value = legendText(item.get('valueLabel')).trim();
        const indicator = item.get('settingsButton')?.getPrivate('customData');
        if (indicator?.isType('HeikinAshi')) {
          const series = item.dataContext;
          const point = series.get('tooltipDataItem') || series.dataItems[series.dataItems.length - 1];
          if (point) value = [['O', 'openValueY'], ['H', 'highValueY'], ['L', 'lowValueY'], ['C', 'valueY']]
            .map(([label, key]) => `[bold]${label}: ${root.numberFormatter.format(point.get(key), '#,###.########')}[/]`).join('');
        }
        if (indicator?.isType('SuperTrend') || indicator?.isType('ZigZag')) {
          const hovered = indicator.get('stockSeries')?.get('tooltipDataItem');
          const time = hovered?.get('valueX') ?? Infinity;
          const candidates = indicator.isType('SuperTrend')
            ? [indicator.upperBandSeries, indicator.lowerBandSeries] : [item.dataContext];
          let latest;
          candidates.forEach(series => {
            const data = series?.dataItems || [];
            for (let i = data.length - 1; i >= 0; i--) {
              const point = data[i], x = point.get('valueX'), y = point.get('valueY');
              if (x <= time && Number.isFinite(y)) {
                if (!latest || x > latest.x) latest = { x, y, series };
                break;
              }
            }
          });
          if (latest) {
            const color = latest.series.get('stroke')?.toCSSHex?.() || '';
            value = `[${color} bold]${root.numberFormatter.format(latest.y, '#,###.########')}[/]`;
          }
        }
        if (value.replace(/\[[^\]]*\]/g, '').trim() && row.last !== value) {
          row.last = value;
          let color = '';
          const slots = [];
          // Update fixed numeric slots in place so changing values never resize a tab.
          value.split(/(\[[^\]]*\])/).forEach(part => {
            if (part.startsWith('[')) {
              color = part.match(/#[0-9a-f]{6}\b/i)?.[0] || '';
            } else if (part.trim()) {
              slots.push({ text: part.trim(), color });
            }
          });
          [...row.values.children].forEach((span, index) => {
            const slot = slots[index];
            if (slot?.text) {
              span.textContent = slot.text;
              span.title = slot.text;
              if (slot.color) span.style.color = slot.color;
            }
          });
        }
      });
    };
    const indicatorTextMeasure = document.createElement('canvas').getContext('2d');
    const arrangeIndicatorRows = () => {
      const available = overlayHost.clientWidth;
      let overflowCount = 0;
      let inlineCount = 0;
      const gap = parseFloat(getComputedStyle(inlineIndicators).columnGap) || 0;
      const rows = [...overlayRows.values()];
      rows.forEach(row => {
        // Measure the normal toolbar presentation only when its name/slot count changes.
        // A chip can wrap, so its current width cannot decide whether it fits back upstairs.
        const signature = row.name.textContent + ':' + row.slotCount;
        if (row.widthSignature !== signature) {
          const probe = row.element.cloneNode(true);
          probe.setAttribute('aria-hidden', 'true');
          probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:max-content;';
          inlineIndicators.append(probe);
          row.toolbarWidth = probe.getBoundingClientRect().width;
          const slot = probe.querySelector('.indicator-values > span');
          row.slotWidth = slot?.getBoundingClientRect().width || 0;
          row.slotFont = slot ? getComputedStyle(slot).font : '10px Arial';
          probe.remove();
          row.widthSignature = signature;
        }
        if (indicatorTextMeasure) indicatorTextMeasure.font = row.slotFont;
        row.valuesFit = !indicatorTextMeasure || [...row.values.children].every(span =>
          indicatorTextMeasure.measureText(span.textContent).width <= row.slotWidth + 1);
      });
      const totalWidth = rows.reduce((width, row) => width + row.toolbarWidth, 0) + Math.max(0, rows.length - 1) * gap;
      // Decide against the full available width, before reserving arrow space.
      // Otherwise the arrows themselves can repeatedly switch the layout to chips.
      const firstFits = rows.length > 0 && rows[0].toolbarWidth <= available && rows[0].valuesFit;
      const target = firstFits ? inlineIndicators : indicatorChips;
      rows.forEach((row, index) => {
        if (target.children[index] !== row.element) target.insertBefore(row.element, target.children[index] || null);
      });
      indicatorChips.hidden = firstFits || rows.length === 0;
      const needsScroll = firstFits && totalWidth > available + 1;
      previousIndicator.hidden = nextIndicator.hidden = !needsScroll;
      previousIndicator.disabled = inlineIndicators.scrollLeft <= 1;
      nextIndicator.disabled = inlineIndicators.scrollLeft + inlineIndicators.clientWidth >= inlineIndicators.scrollWidth - 1;
      if (!firstFits) inlineIndicators.scrollLeft = 0;
    };
    inlineIndicators.addEventListener('scroll', arrangeIndicatorRows);
    root.addDisposer(new am5.Disposer(() => inlineIndicators.removeEventListener('scroll', arrangeIndicatorRows)));
    root.addDisposer(root.events.on('frameended', arrangeIndicatorRows));
    root.addDisposer(resetControl.events.on('click', () => {
      valueLegend.data.clear();
      overlayRows.forEach(row => row.element.remove()); overlayRows.clear();
      overlayHost.hidden = true; indicatorChips.hidden = true;
      previousIndicator.hidden = nextIndicator.hidden = true;
    }));
    valueLegend.setAll({ isMeasured: false, visible: false });
    root.addDisposer(root.events.on('frameended', syncOverlayRows));
    root.addDisposer(valueLegend.data.events.onAll(syncOverlayRows));
    syncOverlayRows();

    let indicatorLegendFrame;
    const refreshIndicatorLegends = () => {
      cancelAnimationFrame(indicatorLegendFrame);
      indicatorLegendFrame = requestAnimationFrame(() => {
        if (layoutRoot.isDisposed() || stockChart.isDisposed()) return;
        stockChart.panels.each(panel => {
          if (panel.isDisposed()) return;
          ['topAxesContainer', 'topPlotContainer', 'plotContainer'].forEach(key => {
            const box = panel[key];
            if (!box || box.isDisposed() || !box.children) return;
            [...box.children.values].forEach(ch => {
              if (ch && !ch.isDisposed() && String(ch.className || '').includes('StockLegend')) hardenStockLegend(ch);
            });
          });
        });
      });
    };
    root.addDisposer(stockChart.indicators.events.on('push', refreshIndicatorLegends));
    const toolbarReadyFrame = requestAnimationFrame(() => {
      if (!layoutRoot.isDisposed()) eaChartToolbarReady();
    });
    root.addDisposer(new am5.Disposer(() => {
      cancelAnimationFrame(indicatorLegendFrame);
      cancelAnimationFrame(toolbarReadyFrame);
    }));

    const searchableDropdownSelector =

      '#chartcontrols .am5stock:nth-child(1) .am5stock-control-list-container, #chartcontrols .am5stock:nth-child(4) .am5stock-control-list-container';



    const syncDrawPanelDropdownTips = () => {

      const drawingTools = document.querySelector('.am5stock-control-drawing-tools');

      if (!drawingTools || getComputedStyle(drawingTools).display === 'none') return;



      drawingTools.querySelectorAll(

        ':scope > .am5stock:not([data-drawing-tool-control="true"]):not([data-drawing-tool-control="true"])',

      ).forEach((stock) => {

        const container = stock.querySelector(':scope > .am5stock-control-list-container');

        const arrow = container?.querySelector('.am5stock-control-list-arrow');

        if (!container || !arrow) return;



        const visible = container.offsetWidth > 0

          && getComputedStyle(container).display !== 'none';

        if (!visible) {

          container.style.removeProperty('--draw-dropdown-tip-left');

          arrow.style.removeProperty('left');

          return;

        }



        const trigger = stock.querySelector(':scope > .am5stock-control-icon')

          || stock.querySelector(':scope > .am5stock-control-button')

          || stock;

        const triggerRect = trigger.getBoundingClientRect();

        const containerRect = container.getBoundingClientRect();

        const center = triggerRect.left + triggerRect.width / 2 - containerRect.left;

        const tipLeft = Math.max(14, Math.min(containerRect.width - 14, center));

        container.style.setProperty('--draw-dropdown-tip-left', `${tipLeft}px`);

        arrow.style.setProperty('left', `${tipLeft}px`);

      });

    };



    const syncSearchDropdownWidths = () => {

      document.querySelectorAll(searchableDropdownSelector).forEach((container) => {

        const visible = container.offsetWidth > 0

          && getComputedStyle(container).display !== 'none';

        if (!visible) {

          delete container.dataset.widthLocked;

          container.style.width = '';

          container.style.minWidth = '';

          container.style.maxWidth = '';

          return;

        }

        if (container.dataset.widthLocked) return;

        const w = container.offsetWidth;

        if (w < 1) return;

        container.style.boxSizing = 'border-box';

        container.style.width = `${w}px`;

        container.style.minWidth = `${w}px`;

        container.style.maxWidth = `${w}px`;

        container.dataset.widthLocked = '1';

      });

    };



    const chartControlsEl = document.getElementById('chartcontrols');

    // The toolbar overlays the canvas. Reserve its height for the whole stack,
    // so moving or expanding an indicator cannot put its header underneath it.
    const reserveChartToolbar = () => {
      if (!chartControlsEl || stockChart.isDisposed()) return;
      const height = Math.ceil(chartControlsEl.offsetHeight) + 2;
      if (panelsContainer.get('paddingTop') !== height) panelsContainer.set('paddingTop', height);
    };
    const chartToolbarHeightObserver = new ResizeObserver(reserveChartToolbar);
    if (chartControlsEl) chartToolbarHeightObserver.observe(chartControlsEl);
    reserveChartToolbar();
    root.addDisposer(new am5.Disposer(() => chartToolbarHeightObserver.disconnect()));

    // Size toolbar menus to the chart/table boundary, not a fixed 300px cap.

    const resizeToolbarMenus = () => {

      const chart = document.getElementById('chartdiv');

      if (!chart || !chartControlsEl) return;

      const pane = chart.closest('.chart-con');

      const paneRect = (pane || chart).getBoundingClientRect();

      const history = document.querySelector('.bottom-section');

      const historyRect = history?.getBoundingClientRect();

      const historyVisible = history && history.getAttribute('aria-hidden') !== 'true'

        && historyRect.height > 0 && historyRect.top > paneRect.top

        && getComputedStyle(history).display !== 'none'

        && getComputedStyle(history).visibility !== 'hidden';

      const bottom = Math.min(window.innerHeight, historyVisible ? historyRect.top : paneRect.bottom);

      if (pane) {

        // Viewport measurements include the platform's CSS zoom; CSS sizes do not.

        const scale = pane.offsetHeight > 0 ? paneRect.height / pane.offsetHeight : 1;

        const overlayHeight = `${Math.max(0, bottom - paneRect.top) / (scale || 1)}px`;

        if (pane.style.getPropertyValue('--indicator-overlay-height') !== overlayHeight) pane.style.setProperty('--indicator-overlay-height', overlayHeight);

      }

      chartControlsEl.querySelectorAll(':scope > .am5stock > .am5stock-control-list-container').forEach(menu => {

        if (menu.closest('.am5stock-control-drawing-tools') || !menu.getClientRects().length) return;

        const list = menu.querySelector('.am5stock-control-list');

        if (!list || !list.getClientRects().length) return;

        const limit = Math.max(0, bottom - 12 - list.getBoundingClientRect().top - (parseFloat(getComputedStyle(menu).paddingBottom) || 0) - (parseFloat(getComputedStyle(list).marginBottom) || 0));

        const height = `${limit}px`;

        if (list.style.maxHeight !== height) list.style.setProperty('max-height', height, 'important');

      });

    };

    let menuResizeFrame;

    const scheduleToolbarMenus = () => {

      if (document.documentElement.classList.contains('chart-layout-transition')) return;

      cancelAnimationFrame(menuResizeFrame);

      menuResizeFrame = requestAnimationFrame(resizeToolbarMenus);

    };

    const toolbarObserver = new MutationObserver(records => { if (hasLayoutMutation(records)) scheduleToolbarMenus(); });

    if (chartControlsEl) toolbarObserver.observe(chartControlsEl, { subtree: true, childList: true, attributes: true, attributeOldValue: true, attributeFilter: ['class', 'style'] });

    const chartSizeObserver = new ResizeObserver(scheduleToolbarMenus);

    const chartSizeTarget = document.getElementById('chartdiv');

    if (chartSizeTarget) chartSizeObserver.observe(chartSizeTarget);

    const chartPaneTarget = chartSizeTarget?.closest('.chart-con');

    if (chartPaneTarget) chartSizeObserver.observe(chartPaneTarget);

    const historyTarget = document.querySelector('.bottom-section');

    if (historyTarget) chartSizeObserver.observe(historyTarget);

    const layoutObserver = new MutationObserver(records => { if (hasLayoutMutation(records)) scheduleToolbarMenus(); });

    if (historyTarget) layoutObserver.observe(historyTarget, { attributes: true, attributeOldValue: true, attributeFilter: ['aria-hidden', 'class', 'style'] });

    scheduleToolbarMenus();

    window.addEventListener('resize', scheduleToolbarMenus);

    root.addDisposer(new am5.Disposer(() => {

      toolbarObserver.disconnect(); chartSizeObserver.disconnect(); layoutObserver.disconnect();

      cancelAnimationFrame(menuResizeFrame);

      window.removeEventListener('resize', scheduleToolbarMenus);

    }));

    let dropdownWidthRaf = 0;

    const scheduleDropdownWidthSync = () => {

      if (document.documentElement.classList.contains('chart-layout-transition')) return;

      cancelAnimationFrame(dropdownWidthRaf);

      dropdownWidthRaf = requestAnimationFrame(() => {

        dropdownWidthRaf = requestAnimationFrame(syncSearchDropdownWidths);

      });

    };



    let drawTipRaf = 0;

    const scheduleDrawDropdownTipSync = () => {

      if (document.documentElement.classList.contains('chart-layout-transition')) return;

      cancelAnimationFrame(drawTipRaf);

      drawTipRaf = requestAnimationFrame(() => {

        drawTipRaf = requestAnimationFrame(syncDrawPanelDropdownTips);

      });

    };



    chartControlsEl?.addEventListener('click', scheduleDropdownWidthSync);

    chartControlsEl?.addEventListener('click', scheduleDrawDropdownTipSync);
    root.addDisposer(new am5.Disposer(() => {
      chartControlsEl?.removeEventListener('click', scheduleDrawDropdownTipSync);
      cancelAnimationFrame(drawTipRaf);
    }));

    chartControlsEl?.addEventListener('input', scheduleDropdownWidthSync, true);

    chartControlsEl?.addEventListener('focusin', scheduleDropdownWidthSync, true);



    const dropdownWidthObserver = new MutationObserver(records => {

      if (!hasLayoutMutation(records)) return;

      scheduleDropdownWidthSync();

      scheduleDrawDropdownTipSync();

    });

    if (chartControlsEl) {

      dropdownWidthObserver.observe(chartControlsEl, {

        childList: true,

        subtree: true,

        attributes: true,

        attributeOldValue: true,

        attributeFilter: ['style', 'class'],

      });

    }



    // Enhance indicator modal selects with UI dropdown clone

    const modalOwnerRoot = root;
    const modalContentCleanup = configureSettingsModalCleanup(stockChart.getPrivate('settingsModal'));
    configureSettingsModalAccessibility(stockChart.getPrivate('settingsModal'), modalContentCleanup);

    const enhanceModalSelects = () => {

      if (modalOwnerRoot.isDisposed() || stockChart.isDisposed()) return;

      const settingsModal = stockChart.getPrivate('settingsModal');

      if (!settingsModal || settingsModal.isDisposed()) return;

      const ownedContent = settingsModal.getPrivate('content');

      ownedContent?.querySelectorAll('.am5stock-control-color .am5stock-control-list-container').forEach(picker => {

        if (picker.dataset.boundedPicker) return;

        picker.dataset.boundedPicker = 'true';

        picker.classList.add('indicator-color-overlay');

        picker.setAttribute('popover', 'manual');

        const syncPicker = () => {

          if (!picker.isConnected || picker.style.display === 'none' || !ownedContent.getClientRects().length) {

            if (picker.matches(':popover-open')) picker.hidePopover();

            return;

          }

          if (!picker.matches(':popover-open')) picker.showPopover();

          const anchor = picker.closest('.am5stock-control-color').getBoundingClientRect();

          const bounds = ownedContent.closest('.chart-con')?.getBoundingClientRect();

          const top = Math.max(8, bounds?.top || 0);

          const bottom = Math.min(window.innerHeight - 8, bounds?.bottom || window.innerHeight);

          const below = Math.max(0, bottom - anchor.bottom - 6);

          const above = Math.max(0, anchor.top - top - 6);

          const height = picker.scrollHeight;

          const up = below < height && above > below;

          const available = up ? above : below;

          const left = Math.max(8, Math.min(anchor.right - picker.offsetWidth, window.innerWidth - picker.offsetWidth - 8));

          const y = up ? anchor.top - Math.min(height, available) - 6 : anchor.bottom + 6;

          picker.dataset.openUp = String(up);

          picker.style.setProperty('--picker-tip', Math.max(10, Math.min(picker.offsetWidth - 10, anchor.left + anchor.width / 2 - left)) + 'px');

          for (const [key, value] of Object.entries({ '--picker-left': left + 'px', '--picker-top': y + 'px', '--picker-height': available + 'px' })) {

            if (picker.style.getPropertyValue(key) !== value) picker.style.setProperty(key, value);

          }

        };

        const observer = new MutationObserver(syncPicker);

        observer.observe(picker, { attributes: true, attributeFilter: ['style'] });

        window.addEventListener('resize', syncPicker);

        modalContentCleanup.add(new am5.Disposer(() => { observer.disconnect(); window.removeEventListener('resize', syncPicker); }));

        syncPicker();

      });

      const modals = ownedContent ? ownedContent.querySelectorAll('.am5-modal-table') : [];

      modals.forEach((table) => {

        if (!table.dataset.numericValidation) {

          table.dataset.numericValidation = 'true';

          const content = table.closest('.am5-modal-content');

          const validateNumbers = () => {

            let valid = true;

            table.querySelectorAll('input[type="number"]').forEach((input, index) => {

              const value = Number(input.value);

              const name = input.closest('.am5-modal-table-row')?.querySelector('.am5-modal-table-heading')?.textContent?.trim() || 'Value';

              const italian = language === 'it';

              let message = '';

              if (!input.value.trim() || !Number.isFinite(value)) message = italian ? 'Inserisci un numero valido.' : 'Enter a valid number.';

              else if (!/^-?(?:\d{1,10}(?:\.\d{0,10})?|\.\d{1,10})$/.test(input.value)) message = italian ? 'Massimo 10 cifre prima e dopo il separatore decimale.' : 'Use at most 10 digits before and after the decimal point.';

              else if (input.min !== '' && value < Number(input.min)) message = italian ? `${name}: minimo ${input.min}.` : `${name} must be at least ${input.min}.`;

              else if (input.max !== '' && value > Number(input.max)) message = italian ? `${name}: massimo ${input.max}.` : `${name} must be at most ${input.max}.`;

              else if (input.step !== 'any' && Number(input.step) > 0) {

                const steps = (value - (Number(input.min) || 0)) / Number(input.step);

                if (Math.abs(steps - Math.round(steps)) > 1e-7) message = italian ? `Usa incrementi di ${input.step}.` : `Use increments of ${input.step}.`;

              }

              input.setCustomValidity(message);

              input.setAttribute('aria-invalid', String(Boolean(message)));

              const errorId = `${root.dom.id || 'chart'}-indicator-error-${index}`;

              const row = input.closest('.am5-modal-table-row');

              let error = row?.querySelector(`[id="${errorId}"]`);

              if (!error && message) {

                error = document.createElement('span');

                error.className = 'indicator-field-error';

                error.id = errorId;

                error.setAttribute('role', 'alert');

                row.appendChild(error);

              }

              if (error) {

                if (error.textContent !== message) error.textContent = message;

                error.hidden = !message;

                input.setAttribute('aria-describedby', error.id);

              }

              if (message) valid = false;

            });

            const save = content?.querySelector('.am5-modal-primary');

            if (save) { save.disabled = !valid; save.setAttribute('aria-disabled', String(!valid)); }

            return valid;

          };

          // Number inputs ignore maxLength. Retain the last lexical value so
          // typing and paste cannot exceed the digit budget or use exponents.
          const acceptedNumbers = new WeakMap();
          table.querySelectorAll('input[type="number"]').forEach(input => {
            acceptedNumbers.set(input, input.value);
          });
          const onBeforeInput = event => {
            if (event.target.matches('input[type="number"]') && /[eE+]/.test(event.data || '')) event.preventDefault();
          };
          const onInput = event => {
            const input = event.target;
            if (input.matches('input[type="number"]')) {
              if (input.value && !/^-?(?:\d{1,10}(?:\.\d{0,10})?|\.\d{1,10})$/.test(input.value)) {
                input.value = acceptedNumbers.get(input) || '';
              } else acceptedNumbers.set(input, input.value);
            }
            validateNumbers();
          };

          const onChange = event => {

            // Preserve invalid text so the user can correct it; amCharts would

            // otherwise silently clamp it before presenting the error.

            if (event.target.matches('input[type="number"]') && !validateNumbers() && event.target.getAttribute('aria-invalid') === 'true') event.stopImmediatePropagation();

            else queueMicrotask(validateNumbers);

          };

          const onSave = event => {

            if (event.target.closest('.am5-modal-primary') && !validateNumbers()) {

              event.preventDefault(); event.stopImmediatePropagation();

              table.querySelector('[aria-invalid="true"]')?.focus();

            }

          };

          table.addEventListener('beforeinput', onBeforeInput);
          table.addEventListener('input', onInput);

          table.addEventListener('change', onChange, true);

          content?.addEventListener('click', onSave, true);

          modalContentCleanup.add(new am5.Disposer(() => {

            table.removeEventListener('beforeinput', onBeforeInput);
            table.removeEventListener('input', onInput);

            table.removeEventListener('change', onChange, true);

            content?.removeEventListener('click', onSave, true);

          }));

          validateNumbers();

        }

        const selects = table.querySelectorAll('select.am5-modal-input, select');

        selects.forEach((select) => {

          if (select.dataset.customEnhanced === 'true') return;

          select.dataset.customEnhanced = 'true';

          Array.from(select.options).forEach(option => { option.text = chartText(option.text, language); });

          // Older saved indicator defaults can reference a removed/missing option.

          // Normalize before amCharts' target listener reads selectedIndex.

          const ensureValidOption = (event) => {

            if (select.selectedIndex >= 0) return;

            const fallback = Array.from(select.options).find(option => option.defaultSelected && !option.disabled)

              || Array.from(select.options).find(option => !option.disabled);

            if (fallback) select.value = fallback.value;

            else event.stopImmediatePropagation();

          };

          select.addEventListener('change', ensureValidOption, true);

          modalContentCleanup.add(new am5.Disposer(() => select.removeEventListener('change', ensureValidOption, true)));

          select.style.display = 'none';



          const wrapper = document.createElement('div');

          wrapper.className = 'am5-custom-select';



          const control = document.createElement('div');

          control.className = 'am5-custom-select-control';

          control.tabIndex = 0;



          const currentOption = select.options[select.selectedIndex] || select.options[0];

          const valueSpan = document.createElement('span');

          valueSpan.className = 'am5-custom-select-value';

          valueSpan.textContent = currentOption ? currentOption.text : '';

          control.title = currentOption ? currentOption.text : '';

          valueSpan.title = currentOption ? currentOption.text : '';



          const indicator = document.createElement('div');

          indicator.className = 'am5-custom-select-indicator';

          indicator.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';



          control.appendChild(valueSpan);

          control.appendChild(indicator);



          const menu = document.createElement('div');

          menu.className = 'am5-custom-select-menu indicator-select-overlay';

          menu.setAttribute('popover', 'manual');



          const updateOptions = () => {

            menu.innerHTML = '';

            Array.from(select.options).forEach((opt) => {

              const item = document.createElement('div');

              item.className = 'am5-custom-select-option' + (opt.selected ? ' is-selected' : '');

              item.textContent = opt.text;

              item.dataset.value = opt.value;



              item.addEventListener('click', (e) => {

                e.stopPropagation();

                select.value = opt.value;

                valueSpan.textContent = opt.text;

                valueSpan.title = opt.text;

                control.title = opt.text;

                select.dispatchEvent(new Event('change', { bubbles: true }));

                select.dispatchEvent(new Event('input', { bubbles: true }));

                wrapper.classList.remove('is-open');

                updateOptions();

              });



              menu.appendChild(item);

            });

          };



          updateOptions();



          control.addEventListener('click', (e) => {

            e.stopPropagation();

            const isOpen = wrapper.classList.contains('is-open');

            document.querySelectorAll('.am5-custom-select.is-open').forEach((w) => {

              w.classList.remove('is-open', 'open-up');

              const m = w.querySelector('.am5-custom-select-menu');

              if (m) {

                m.style.removeProperty('max-height');

                m.style.removeProperty('overflow-y');

              }

            });

            if (!isOpen) {

              const rect = control.getBoundingClientRect();

              const fullMenuHeight = (select.options.length || 5) * 24 + 4;



              const chartBounds = ownedContent.closest('.chart-con')?.getBoundingClientRect();

              const visibleTop = Math.max(8, chartBounds?.top || 0);

              const visibleBottom = Math.min(window.innerHeight - 8, chartBounds?.bottom || window.innerHeight);



              const spaceBelow = Math.max(0, visibleBottom - rect.bottom);

              const spaceAbove = Math.max(0, rect.top - visibleTop);



              let openUp = false;

              let availableSpace = spaceBelow;



              if (spaceBelow >= fullMenuHeight) {

                openUp = false;

                availableSpace = spaceBelow;

              } else if (spaceAbove >= fullMenuHeight) {

                openUp = true;

                availableSpace = spaceAbove;

              } else {

                // Pick whichever side has more room

                if (spaceBelow >= spaceAbove) {

                  openUp = false;

                  availableSpace = spaceBelow;

                } else {

                  openUp = true;

                  availableSpace = spaceAbove;

                }

              }



              if (openUp) {

                wrapper.classList.add('open-up');

              } else {

                wrapper.classList.remove('open-up');

              }



              const maxAllowed = Math.min(fullMenuHeight, Math.max(availableSpace, 60));

              menu.style.setProperty('max-height', maxAllowed + 'px', 'important');

              menu.style.setProperty('overflow-y', 'auto', 'important');

              menu.style.setProperty('overflow-x', 'hidden', 'important');



              wrapper.classList.add('is-open');

              menu.style.setProperty('width', rect.width + 'px', 'important');

              // A top-layer popover resolves percentage min-width against the

              // viewport, not the select. Override the legacy min-width:100%.

              menu.style.setProperty('min-width', rect.width + 'px', 'important');

              menu.style.setProperty('max-width', rect.width + 'px', 'important');

              menu.style.setProperty('right', 'auto', 'important');

              menu.style.setProperty('bottom', 'auto', 'important');

              menu.style.setProperty('left', Math.max(8, Math.min(rect.left, window.innerWidth - rect.width - 8)) + 'px', 'important');

              menu.style.setProperty('top', (openUp ? rect.top - maxAllowed - 4 : rect.bottom + 4) + 'px', 'important');

              menu.showPopover();

            }

          });



          control.setAttribute('role', 'combobox');
          control.setAttribute('aria-haspopup', 'listbox');
          control.setAttribute('aria-expanded', 'false');
          control.setAttribute('aria-label', select.closest('.am5-modal-table-row')?.querySelector('.am5-modal-table-heading')?.textContent || 'Setting');
          menu.setAttribute('role', 'listbox');
          const syncSelectAccessibility = () => {
            control.setAttribute('aria-expanded', String(wrapper.classList.contains('is-open')));
            menu.querySelectorAll('.am5-custom-select-option').forEach(item => {
              item.tabIndex = -1;
              item.setAttribute('role', 'option');
              item.setAttribute('aria-selected', String(item.dataset.value === select.value));
            });
          };
          const selectObserver = new MutationObserver(syncSelectAccessibility);
          selectObserver.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
          selectObserver.observe(menu, { childList: true });
          const selectKeydown = event => {
            if (!['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End', 'Escape', 'Tab'].includes(event.key)) return;
            const open = wrapper.classList.contains('is-open');
            if (event.key === 'Tab') { if (open) control.click(); return; }
            event.preventDefault(); event.stopPropagation();
            if (event.key === 'Escape') { if (open) control.click(); control.focus(); return; }
            if (event.key === 'Enter' || event.key === ' ') {
              if (event.target.classList.contains('am5-custom-select-option')) { event.target.click(); control.focus(); }
              else control.click();
              return;
            }
            if (!open) control.click();
            const options = [...menu.children].filter(item => !select.options[[...menu.children].indexOf(item)]?.disabled);
            const focusedIndex = options.indexOf(document.activeElement);
            const current = focusedIndex >= 0 ? focusedIndex : options.findIndex(item => item.dataset.value === select.value);
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : current < 0 ? (event.key === 'ArrowUp' ? options.length - 1 : 0) : (current + (event.key === 'ArrowUp' ? -1 : 1) + options.length) % options.length;
            options[next]?.focus();
          };
          wrapper.addEventListener('keydown', selectKeydown);
          modalContentCleanup.add(new am5.Disposer(() => { selectObserver.disconnect(); wrapper.removeEventListener('keydown', selectKeydown); }));
          syncSelectAccessibility();

          wrapper.appendChild(control);

          wrapper.appendChild(menu);



          select.parentNode.insertBefore(wrapper, select.nextSibling);

        });



        // Column alignment: when a modal has rows with both inputs and color controls,

        // align all inputs into the left column and colors into the right column

        const rows = table.querySelectorAll('.am5-modal-table-row');

        let hasMixedRow = false;

        rows.forEach((row) => {

          const hasColor = row.querySelector('.am5stock-control-color, .am5stock-control-icon');

          const hasInput = row.querySelector('input, select, .am5-custom-select');

          if (hasInput && hasColor) {

            hasMixedRow = true;

          }

        });



        if (hasMixedRow) {

          table.classList.add('am5-modal-has-color-col');

          rows.forEach((row) => {

            const hasColor = row.querySelector('.am5stock-control-color, .am5stock-control-icon');

            const cells = row.querySelectorAll('.am5-modal-table-cell');

            cells.forEach((cell) => {

              if (cell.querySelector('.am5stock-control-color, .am5stock-control-icon')) {

                cell.classList.add('am5-cell-color');

                cell.style.removeProperty('margin-right');

              } else if (!hasColor) {

                cell.classList.add('am5-cell-no-color');

                cell.style.setProperty('margin-right', '32px', 'important');

              } else {

                cell.classList.remove('am5-cell-no-color');

                cell.style.removeProperty('margin-right');

              }

            });

          });

        } else {

          table.classList.remove('am5-modal-has-color-col');

          rows.forEach((row) => {

            const cells = row.querySelectorAll('.am5-modal-table-cell');

            cells.forEach((cell) => {

              cell.classList.remove('am5-cell-no-color');

              cell.style.removeProperty('margin-right');

              if (cell.querySelector('.am5stock-control-color, .am5stock-control-icon')) {

                cell.classList.add('am5-cell-color');

              }

            });

          });

        }



        // Multi-column layout only when modal content does not fit the screen or has many rows

        const modalContent = table.closest('.am5-modal-content');

        if (modalContent) {

          const previousClose = modalContent.querySelector('.indicator-modal-close');

          if (previousClose?.dataset.modalOwnerVersion !== '2') {

            previousClose?.remove();

            const close = document.createElement('button');

            close.type = 'button';

            close.className = 'popup-close-button indicator-modal-close';

            close.dataset.modalOwnerVersion = '2';

            close.setAttribute('aria-label', 'Close');

            close.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" /></svg>';

            close.addEventListener('click', () => {

              if (modalOwnerRoot.isDisposed() || settingsModal.isDisposed()) return;

              if (settingsModal.getPrivate('content') !== modalContent) return;

              settingsModal.cancel();

            });

            modalContent.appendChild(close);

          }

          const availHeight = window.innerHeight - 90;

          const isOverflowing = rows.length > 5 || (modalContent.offsetHeight > availHeight);

          if (isOverflowing) {

            modalContent.classList.add('am5-modal-wide');

          } else {

            modalContent.classList.remove('am5-modal-wide');

          }

        }

      });

    };



    const closeModalSelects = () => {

      document.querySelectorAll('.am5-custom-select.is-open').forEach((w) => {

        w.classList.remove('is-open', 'open-up');

        const m = w.querySelector('.am5-custom-select-menu');

        if (m) {

          m.style.removeProperty('max-height');

          m.style.removeProperty('overflow-y');

        }

      });

    };
    document.addEventListener('click', closeModalSelects);
    modalOwnerRoot.addDisposer(new am5.Disposer(() => document.removeEventListener('click', closeModalSelects)));

    const modalObserver = new MutationObserver(enhanceModalSelects);

    modalObserver.observe(document.body, {

      childList: true,

      subtree: true,

    });

    root.addDisposer(new am5.Disposer(() => modalObserver.disconnect()));



    const ensureDrawPanelClose = (panel) => {

      if (panel.querySelector('.draw-panel-close')) return;



      const closeBtn = document.createElement('button');

      closeBtn.type = 'button';

      closeBtn.className = 'draw-panel-close';

      closeBtn.setAttribute('aria-label', 'Close drawing panel');

      closeBtn.setAttribute('data-tooltip', 'Close');

      closeBtn.innerHTML =

        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" fill="none"/></svg>';

      closeBtn.addEventListener('click', (e) => {

        e.preventDefault();

        e.stopPropagation();

        closeAllDrawPanels();

      });

      panel.insertBefore(closeBtn, panel.firstChild);

    };



    const measureAxisBandHeight = (chartPaneEl, chartdivEl) => {

      const fallback = parseFloat(

        getComputedStyle(chartPaneEl).getPropertyValue('--chart-axis-reserve'),

      ) || 40;



      if (!chartdivEl) return fallback;



      const divRect = chartdivEl.getBoundingClientRect();

      let axisTop = divRect.bottom;



      chartdivEl.querySelectorAll('text').forEach((node) => {

        const rect = node.getBoundingClientRect();

        if (rect.width < 1 || rect.height < 1) return;

        if (rect.bottom <= divRect.top + divRect.height * 0.72) return;

        if (rect.top < axisTop) axisTop = rect.top;

      });



      if (axisTop < divRect.bottom - 1) {

        return Math.max(fallback, Math.ceil(divRect.bottom - axisTop + 4));

      }



      return fallback;

    };



    const ensureDrawPanelAxisMask = (panel, bandHeight) => {

      let mask = panel.querySelector('.draw-panel-axis-mask');

      if (!mask) {

        mask = document.createElement('div');

        mask.className = 'draw-panel-axis-mask';

        mask.setAttribute('aria-hidden', 'true');

      }

      mask.style.height = `${bandHeight}px`;

      if (mask.parentElement !== panel) {

        panel.insertBefore(mask, panel.firstChild);

      } else if (panel.firstChild !== mask) {

        panel.insertBefore(mask, panel.firstChild);

      }

    };



    const measureDrawingLayoutMetrics = (chartPaneEl, chartControlsEl) => {

      const rowFallback = parseFloat(

        getComputedStyle(chartPaneEl).getPropertyValue('--chart-toolbar-row-height'),

      ) || 37;



      if (!chartPaneEl || !chartControlsEl) {

        return { closeHeight: rowFallback, subtoolbarTop: rowFallback, subRowHeight: rowFallback };

      }



      const paneRect = chartPaneEl.getBoundingClientRect();

      let rowBottom = 0;

      let hoverBottom = 0;



      chartControlsEl.querySelectorAll(':scope > .am5stock, :scope > #ea-chart-control').forEach((el) => {

        const style = getComputedStyle(el);

        if (style.display === 'none') return;

        const rect = el.getBoundingClientRect();

        if (rect.height < 1) return;

        rowBottom = Math.max(rowBottom, rect.bottom - paneRect.top);

        const svg = el.querySelector('.am5stock-control-icon svg');

        const svgRect = svg?.getBoundingClientRect();

        if (svgRect && svgRect.height > 1) {

          hoverBottom = Math.max(hoverBottom, svgRect.bottom - paneRect.top);

        }

      });



      if (rowBottom < 1) {

        rowBottom = chartControlsEl.getBoundingClientRect().bottom - paneRect.top;

      }



      const toolbarBand = Math.max(24, Math.ceil(rowBottom));

      const hoverBand = hoverBottom > 1 ? Math.ceil(hoverBottom) - 1 : toolbarBand;

      return {

        closeHeight: toolbarBand,

        subtoolbarTop: hoverBand,

        subRowHeight: rowFallback,

      };

    };



    const syncDrawingSidebarLayout = () => {

      const chartPane = document.querySelector('.chart-con');

      if (drawingSurfaceMotion || chartPane?.getAttribute('data-drawing-anim') === 'close') return;

      const chartControls = document.getElementById('chartcontrols');

      const chartdiv = document.getElementById('chartdiv');

      const drawingTools = document.querySelector('.am5stock-control-drawing-tools');

      const panel = getDrawingSidebarPanel();



      const panelOpen = !!panel

        && getComputedStyle(panel).display !== 'none'

        && panel.offsetWidth > 0;



      const drawingToolsAmOpen = !!drawingTools

        && (drawingControl.get('active') || getComputedStyle(drawingTools).display !== 'none');



      if (!panelOpen && !drawingToolsAmOpen) {

        chartControls?.style.removeProperty('padding-left');

        clearDrawingSubtoolbarLayout(drawingTools);

        chartPane?.setAttribute('data-drawing-open', 'false');

        chartPane?.setAttribute('data-drawing-toolbar', 'false');

        chartPane?.closest('.chart-box')?.setAttribute('data-drawing-sidebar-open', 'false');

        chartPane?.style.removeProperty('--chart-axis-band');

        chartPane?.style.removeProperty('--draw-sidebar-width');

        chartPane?.style.removeProperty('--draw-close-height');

        chartPane?.style.removeProperty('--draw-subtoolbar-top');

        return;

      }



      const sidebarW = panelOpen

        ? (panel.offsetWidth || 44)

        : (drawingToolsAmOpen ? 44 : 0);



      chartPane?.setAttribute('data-drawing-open', panelOpen ? 'true' : 'false');

      chartPane?.setAttribute('data-drawing-toolbar', drawingToolsAmOpen ? 'true' : 'false');

      chartPane?.setAttribute(

        'data-drawing-subtoolbar-collapsed',

        drawingSubtoolbarCollapsed ? 'true' : 'false',

      );

      chartPane?.closest('.chart-box')?.setAttribute(

        'data-drawing-sidebar-open',

        panelOpen ? 'true' : 'false',

      );

      chartPane?.style.setProperty('--draw-sidebar-width', `${sidebarW}px`);



      if (sidebarW > 0) {

        chartControls.style.setProperty('padding-left', `${sidebarW + 4}px`, 'important');

      } else {

        chartControls?.style.removeProperty('padding-left');

      }



      // Let drawing-mode CSS (padding-bottom: 0) apply before measuring icon row.

      void chartControls.offsetHeight;



      const { closeHeight, subtoolbarTop, subRowHeight } = measureDrawingLayoutMetrics(

        chartPane,

        chartControls,

      );

      chartPane?.style.setProperty('--draw-close-height', `${closeHeight}px`);

      chartPane?.style.setProperty('--draw-subtoolbar-top', `${subtoolbarTop}px`);



      if (drawingToolsAmOpen) {

        ensureDrawingSubtoolbarToggle(drawingTools);

        applyDrawingSubtoolbarLayout(

          drawingTools,

          chartPane,

          sidebarW || 44,

          subtoolbarTop,

          subRowHeight,

        );

      } else {

        clearDrawingSubtoolbarLayout(drawingTools);

      }



      if (!panelOpen) return;



      const extension = drawingControl.getPrivate('extensionControl');

      extension?.set('forceHidden', true);

      extension?.hide();

      ensureDrawingToolActiveHook();

      ensureDrawingSidebarExpandHook(panel);



      ensureDrawPanelClose(panel);



      panel.style.top = '0';

      panel.style.setProperty('left', '0', 'important');

      panel.style.margin = '0';

      panel.style.padding = '0';

      panel.style.borderRadius = '0';

      panel.style.borderBottomLeftRadius = '0';

      panel.style.borderBottomRightRadius = '0';



      const axisBandHeight = measureAxisBandHeight(chartPane, chartdiv);



      // Stretch the sidebar down to the Positions/tabs rail so there is no gap

      // under the chart (resize strip) before the bottom panel.

      const accountPanel = chartPane?.closest('.direction-col')?.querySelector('.bottom-section');

      const bottomRail = accountPanel?.querySelector('.tabs-section-acc') ?? accountPanel;

      const accountHidden = accountPanel?.getAttribute('aria-hidden') === 'true';

      const tabsTop = accountHidden

        ? Math.min(window.innerHeight, chartPane.closest('.direction-col').getBoundingClientRect().bottom)

        : bottomRail?.getBoundingClientRect().top;

      const chartBottom = chartdiv?.getBoundingClientRect().bottom

        ?? chartPane?.getBoundingClientRect().bottom

        ?? window.innerHeight;



      panel.style.removeProperty('max-height');

      panel.style.overflow = 'hidden';

      if (Number.isFinite(tabsTop) && tabsTop > 0) {

        // Fixed positioning is relative to the transformed chart pane.

        const panelTop = panel.getBoundingClientRect().top;

        panel.style.setProperty('bottom', 'auto', 'important');

        panel.style.setProperty('height', `${Math.max(0, tabsTop - panelTop)}px`, 'important');

      } else {

        panel.style.removeProperty('height');

        panel.style.bottom = '0';

      }

      chartPane?.style.setProperty('--chart-axis-band', `${axisBandHeight}px`);

      ensureDrawPanelAxisMask(panel, axisBandHeight);



      // Keep the axis mask on the chart time-axis, not at the new panel foot.

      const mask = panel.querySelector('.draw-panel-axis-mask');

      if (mask && Number.isFinite(tabsTop) && tabsTop > 0) {

        const offsetFromPanelBottom = Math.max(0, Math.round(tabsTop - chartBottom));

        mask.style.bottom = `${offsetFromPanelBottom}px`;

        mask.style.height = `${axisBandHeight}px`;

      }



      const list = panel.querySelector('.am5stock-control-list');

      if (!list) return;



      list.style.removeProperty('max-height');

      list.style.removeProperty('height');

      list.style.display = 'flex';

      list.style.flexDirection = 'column';

      list.style.removeProperty('padding-top');

      list.style.removeProperty('padding-bottom');



      const items = list.querySelectorAll(

        'li.am5stock-list-item:not(.am5stock-list-heading):not(.am5stock-disabled)',

      );

      if (!items.length) return;



      const gap = DRAW_SIDEBAR_GAP;

      const sampleH = items[0].getBoundingClientRect().height || 24;

      let contentH = 0;

      items.forEach((item) => {

        contentH += item.getBoundingClientRect().height || sampleH;

      });



      const listStyles = getComputedStyle(list);

      const padTop = parseFloat(listStyles.paddingTop) || 0;

      const padBottom = parseFloat(listStyles.paddingBottom) || 0;

      const available = list.clientHeight - padTop - padBottom;



      list.style.gap = `${gap}px`;

      list.style.removeProperty('overflow-y');



      const totalH = contentH + gap * Math.max(0, items.length - 1);

      list.classList.toggle('is-scrollable', totalH > available);



      if (!activeDrawingSidebarToolId && drawingControl.get('tool')) {

        activeDrawingSidebarToolId = drawingControl.get('tool');

      }



      applyDrawingSidebarActiveState(panel);

      scheduleDrawDropdownTipSync();

      if (pendingDrawingIntro) {

        pendingDrawingIntro = false;

        chartPane?.setAttribute('data-drawing-anim', 'open');

        animateDrawingSurface(false, () => {

          chartPane?.removeAttribute('data-drawing-anim');

          scheduleDrawingSidebarSync();

        });

      }

    };



    let drawingLayoutFrame = null;

    const scheduleDrawingSidebarSync = () => {

      if (drawingLayoutFrame !== null || drawingSurfaceMotion || document.documentElement.classList.contains('chart-layout-transition')) return;

      drawingLayoutFrame = requestAnimationFrame(() => {

        drawingLayoutFrame = null;

        syncDrawingSidebarLayout();

        animateToolbarPositions();

      });

    };

    root.addDisposer(new am5.Disposer(() => {

      if (drawingLayoutFrame !== null) cancelAnimationFrame(drawingLayoutFrame);

    }));

    scheduleDrawingSidebarSyncRef = scheduleDrawingSidebarSync;

    const refreshAfterLayout = () => {

      scheduleToolbarMenus();

      scheduleDropdownWidthSync();

      scheduleDrawingSidebarSync();

      scheduleDrawDropdownTipSync();

    };

    window.addEventListener('chart-layout-end', refreshAfterLayout);

    root.addDisposer(new am5.Disposer(() => window.removeEventListener('chart-layout-end', refreshAfterLayout)));



    // Opening the draw control always starts with both panels expanded.

    drawingControl.on('active', (active) => {

      if (!toolbarBeforeLayout) toolbarBeforeLayout = captureToolbarPositions();

      [undoDrawingControl, redoDrawingControl].forEach((control) => {

        control.set('visible', !!active);

        if (active) control.show();

        else control.hide();

      });

      const chartPane = document.querySelector('.chart-con');

      const extensionControl = drawingControl.getPrivate('extensionControl');

      extensionControl?.set('forceHidden', true);

      extensionControl?.hide();

      const shouldAnimateOpen = active && !wasDrawingControlActive;

      wasDrawingControlActive = active;



      if (drawingOpenAnimTimer) {

        window.clearTimeout(drawingOpenAnimTimer);

        drawingOpenAnimTimer = null;

      }



      if (!active) {

        chartPane?.removeAttribute('data-drawing-anim');

        scheduleDrawingSidebarSync();

        return;

      }



      drawingSubtoolbarCollapsed = false;

      document

        .querySelector('.am5stock-control-drawing-tools')

        ?.setAttribute('data-collapsed', 'false');

      chartPane?.setAttribute('data-drawing-subtoolbar-collapsed', 'false');



      drawingControl.getPrivate('toolControl')?.set('active', true);



      if (shouldAnimateOpen) {

        pendingDrawingIntro = true;

        scheduleDrawingSidebarSync();

        return;

      }



      chartPane?.removeAttribute('data-drawing-anim');

      scheduleDrawingSidebarSync();

    });



    const openDrawingToolPicker = event => {

      const trigger = event.target?.closest?.('.am5stock[data-drawing-tool-control="true"], .am5stock[data-drawing-tool-control="true"]');

      if (!trigger || event.target.closest('.am5stock-control-list-container')) return;

      if (!drawingControl.get('active')) return;

      event.preventDefault();

      event.stopImmediatePropagation();

      drawingControl.getPrivate('toolControl')?.set('active', true);

      drawingControl.getPrivate('toolControl')?.getPrivate('list')?.show();

      scheduleDrawingSidebarSync();

    };

    const drawButton = drawingControl.getPrivate('button');

    const closeFromMainDrawButton = event => {

      if (!drawingControl.get('active')) return;

      event.preventDefault();

      event.stopImmediatePropagation();

      closeAllDrawPanels();

    };

    drawButton.addEventListener('click', closeFromMainDrawButton, true);

    root.addDisposer(new am5.Disposer(() => drawButton.removeEventListener('click', closeFromMainDrawButton, true)));

    chartControlsEl?.addEventListener('click', openDrawingToolPicker, true);

    chartControlsEl?.addEventListener('click', scheduleDrawingSidebarSync);



    const drawingSidebarObserver = new MutationObserver(records => { if (hasLayoutMutation(records)) scheduleDrawingSidebarSync(); });

    if (chartControlsEl) {

      drawingSidebarObserver.observe(chartControlsEl, {

        childList: true,

        subtree: true,

        attributes: true,

        attributeOldValue: true,

        attributeFilter: ['style', 'class'],

      });

    }



    const chartPane = document.querySelector('.chart-con');

    const chartPaneResizeObserver = chartPane

      ? new ResizeObserver(scheduleDrawingSidebarSync)

      : null;

    chartPaneResizeObserver?.observe(chartPane);



    const chartBox = document.querySelector('.chart-box');

    const chartBoxResizeObserver = chartBox

      ? new ResizeObserver(scheduleDrawingSidebarSync)

      : null;

    chartBoxResizeObserver?.observe(chartBox);



    let lastAxisLayoutSync = 0;

    const frameEndedDisposer = root.events.on('frameended', () => {

      if (!document.querySelector('.chart-con[data-drawing-open="true"]')

        && !document.querySelector('.chart-con[data-drawing-toolbar="true"]')) return;

      const now = Date.now();

      if (now - lastAxisLayoutSync < 250) return;

      lastAxisLayoutSync = now;

      scheduleDrawingSidebarSync();

    });

    scheduleDrawingSidebarSync();



    const prevCleanup = clickOutsideCleanup;

    clickOutsideCleanup = () => {

      prevCleanup();

      chartControlsEl?.removeEventListener('click', scheduleDropdownWidthSync);

      chartControlsEl?.removeEventListener('input', scheduleDropdownWidthSync, true);

      chartControlsEl?.removeEventListener('focusin', scheduleDropdownWidthSync, true);

      chartControlsEl?.removeEventListener('click', openDrawingToolPicker, true);

      chartControlsEl?.removeEventListener('click', scheduleDrawingSidebarSync);

      cancelAnimationFrame(dropdownWidthRaf);

      dropdownWidthObserver.disconnect();

      drawingSidebarObserver.disconnect();

      chartPaneResizeObserver?.disconnect();

      chartBoxResizeObserver?.disconnect();

      frameEndedDisposer.dispose();

    };



    //#region Load initial data

    try {

      loadChartData(valueSeries);

    } catch (error) {

      console.error('Error loading chart data:', error);

      console.log(error);

    }

  //   if (savedClickedPosition) {

  //     createChartBulletClosePosition(savedClickedPosition);

  // }



    chartRef.current = stockChart;

    valueSeriesRef.current = valueSeries;

    createChartBullets();

    setChartInitialized(true);



    // Return cleanup function

    return () => {

      clickOutsideCleanup();
      for (const ref of [currentLabel2Ref, currentLabelNew2Ref, currentValueDataItem2Ref, currentValueDataItemNewRef]) {
        const owner = ref.current?.root || ref.current?.component?.root;
        if (owner === layoutRoot) ref.current = null;
      }

      if (!layoutRoot.isDisposed()) layoutRoot.dispose();

      if (chartRef.current?.root === layoutRoot) chartRef.current = null;

      if (valueSeriesRef.current?.root === layoutRoot) valueSeriesRef.current = null;

      if (volumeSeriesRef.current?.root === layoutRoot) volumeSeriesRef.current = null;

    };

  };



  const volumeFor = series => {

    const volume = volumeSeriesRef.current;

    return volume && !volume.isDisposed() && volume.root === series.root ? volume : null;

  };



  const setChartRows = (series, rows) => {

    liveTickIdentityRef.current = createLiveTickIdentity();

    volumeFor(series)?.data.setAll(rows);

    series.data.setAll(rows);

  };



  const loadChartData = (series, dateAxis, isPanEnded = false, forceRefresh = false) => {

    if (!chartRequestReady || !series || series.isDisposed()) return Promise.resolve(false);

    if (isPanEnded) {

      if (dateAxis.get('start') > 0.01) return Promise.resolve(true);

      const current = currentChartDataRef.current;

      const additional = olderCandles(allChartDataRef.current, current, candleLength);

      if (!additional.length) return Promise.resolve(true);

      const start = dateAxis.get('start'), end = dateAxis.get('end'), count = current.length;

      const volume = volumeFor(series);

      if (volume) reconcileCandles(volume.data, additional);

      reconcileCandles(series.data, additional);

      currentChartDataRef.current = additional.concat(current);

      // Keep the same candles under the pointer when older rows are prepended.

      const total = count + additional.length;

      dateAxis.zoom((start * count + additional.length) / total, (end * count + additional.length) / total, 0);

      createChartBullets();

      return Promise.resolve(true);

    }

    if (!forceRefresh && loadedChartRequestKeyRef.current === chartRequestKey) {

      setChartRows(series, currentChartDataRef.current);

      setDataReady(true);

      window.dispatchEvent(new CustomEvent('symbol-chart-ready', { detail: { symbol: selectedAuthSymbol } }));

      return Promise.resolve(true);

    }

    if (pendingChartSeriesRef.current?.series === series) return pendingChartSeriesRef.current.promise;

    const tailAtRequest = series.data.getIndex(series.data.length - 1);

    const request = am5.net.load(API_ENDPOINT_KLINES_MT(

      selectedAuthSymbol, selectedTimeFrame, requestUserId, requestSymbolId, requestCategoryId,

    ), series).then(result => {

      if (series.isDisposed() || series.root.isDisposed() || series !== valueSeriesRef.current) return false;

      const chartData = normalizeHistory(am5.JSONParser.parse(result.response).data);

      if (!chartData.length) throw new Error('No valid candles in history response');

      const volume = volumeFor(series);

      if (forceRefresh && series.data.length) {

        const liveTail = series.data.getIndex(series.data.length - 1);

        const firstDate = series.data.getIndex(0).Date;

        const recovered = selectRecoveryRows(chartData, firstDate, liveTail, tailAtRequest, series.data.values);

        const interval = getChartIntervalMs(selectedTimeFrame);

        const anchor = chartData[chartData.length - 1].Date;

        if (volume) {

          removeMisalignedCandles(volume.data, interval, anchor);

          reconcileCandles(volume.data, recovered);

        }

        removeMisalignedCandles(series.data, interval, anchor);

        reconcileCandles(series.data, recovered);

        currentChartDataRef.current = [...series.data.values];

        const all = new Map(chartData.map(row => [row.Date, row]));

        currentChartDataRef.current.forEach(row => all.set(row.Date, row));

        allChartDataRef.current = [...all.values()].sort((a, b) => a.Date - b.Date);

        return true;

      }

      allChartDataRef.current = chartData;

      const rows = chartData.slice(-candleLength);

      currentChartDataRef.current = rows;

      loadedChartRequestKeyRef.current = chartRequestKey;

      setChartRows(series, rows);

      createChartBullets();

      window.dispatchEvent(new CustomEvent('symbol-chart-ready', { detail: { symbol: selectedAuthSymbol } }));

      series.root.events.once('frameended', () => {

        if (!series.isDisposed() && !series.root.isDisposed()) setChartLoading(false);

      });

      setDataReady(true);

      return true;

    }).catch(err => {

      console.warn('[Chart] klines load failed:', err?.message || err);

      if (!series.isDisposed() && !series.root.isDisposed()) setChartLoading(false);

      return false;

    }).finally(() => {

      if (pendingChartSeriesRef.current?.series === series) pendingChartSeriesRef.current = null;

    });

    pendingChartSeriesRef.current = { series, promise: request };

    return request;

  };



  const createChartBullets = () => {

    const data = markerDataRef.current;

    const groups = data.showBullets

      ? groupTradeMarkers(data.openPositions, data.closedPositionsAll, data.selectedAuthSymbol, getChartIntervalMs(data.selectedTimeFrame))

      : new Map();

    tradeMarkersRef.current.update(valueSeriesRef.current, groups,

      [data.selectedStyle.buyColor, data.selectedStyle.sellColor, data.chartColors.text],

      (root, series, item, positions, direction) => {

        const isBuy = direction === 'Buy';

        const open = positions.filter(p => !p.closed).map(p => p.id).join(', ') || 'None';

        const closed = positions.filter(p => p.closed).map(p => p.id).join(', ') || 'None';

        const arrow = am5.Graphics.new(root, {

          svgPath: isBuy ? 'M0,10 L5,0 L10,10 Z' : 'M0,0 L5,10 L10,0 Z',

          fill: am5.color(isBuy ? data.selectedStyle.buyColor : data.selectedStyle.sellColor),

          stroke: am5.color(data.chartColors.text), strokeWidth: 1,

          centerY: am5.p50, centerX: am5.p50, dy: isBuy ? 20 : -20,

          tooltipText: 'Open: ' + open + '\nClosed: ' + closed,

        });

        return am5.Bullet.new(root, { field: isBuy ? 'high' : 'low', sprite: arrow });

      });

  };



// useEffect(() => {

//   if (clickedPosition) {

//     createChartBulletClosePosition(clickedPosition);

//   }

// }, [chartInitialized, clickedPosition]);







// useEffect(() => {

//   if (root && valueSeriesRef.current && clickedPosition) {

//     createChartBulletClosePosition(clickedPosition);

//   }

// }, [root, valueSeriesRef.current, clickedPosition]);







// let savedClickedPosition = null;

// let orangeBullets = [];



// const createChartBulletClosePosition = (clickedPosition) => {

//   if (!clickedPosition) {

//     console.warn("No clicked position provided.");

//     return;

//   }



//   const valueSeries = valueSeriesRef.current;



//   if (!valueSeries) {

//     console.error("valueSeriesRef is not initialized.");

//     return;

//   }

//   orangeBullets.forEach((bullet) => bullet.dispose());

//   orangeBullets = [];



//   if (showBullets) {

//     const { id, symbol, closedAt, direction } = clickedPosition;



//     let targetCandle = null;



//     valueSeries.bullets.push(function (root, series, dataItem) {

//       const candleStartTime = new Date(dataItem.dataContext.Date).getTime();

//       const closedTime = new Date(closedAt).getTime();

//       const candleDuration = {

//         '1m': 60 * 1000,

//         '5m': 5 * 60 * 1000,

//         '15m': 15 * 60 * 1000,

//         '30m': 30 * 60 * 1000,

//         '1h': 60 * 60 * 1000,

//         '4h': 4 * 60 * 60 * 1000,

//         '1d': 24 * 60 * 60 * 1000,

//       }[selectedTimeFrame];



//       const isWithinCandle =

//         closedTime >= candleStartTime &&

//         closedTime < candleStartTime + candleDuration;



//       if (symbol === selectedAuthSymbol && isWithinCandle) {

//         // Save the target candle for zooming

//         targetCandle = dataItem.dataContext;



//         const isBuy = direction === "Buy";



//         const svgPath = isBuy

//           ? "M0,0 L5,10 L10,0 Z"

//           : "M0,10 L5,0 L10,10 Z";



//         const bullet = am5.Graphics.new(root, {

//           svgPath: svgPath,

//           fill: isBuy ? am5.color("rgb(17, 209, 97)") : am5.color("rgb(245, 36, 36)"),

//           stroke: am5.color("#ffffff"),

//           strokeWidth: 1,

//           centerX: am5.p50,

//           centerY: am5.p50,

//           dy: isBuy ? -20 : 20,

//           tooltipText: `Position ID: ${id}\nDirection: ${direction}\nSymbol: ${symbol}\nClosed At: ${new Date(closedAt).toLocaleString()}`,

//         });



//         const newBullet = am5.Bullet.new(root, {

//           field: isBuy ? "high" : "low",

//           sprite: bullet,

//         });



//         orangeBullets.push(newBullet);

//         return newBullet;

//       }

//     });



//     if (targetCandle) {

//       const xAxis = valueSeries.get("xAxis");

//       if (xAxis) {



//         const targetDate = targetCandle.Date;

//         const zoomStartDate = new Date(targetDate - 2 * 60 * 1000);

//         const zoomEndDate = new Date(targetDate + 2 * 60 * 1000);



//         xAxis.zoomToDates(zoomStartDate, zoomEndDate);

//         console.log("Chart zoomed to candle:", targetCandle);

//       } else {

//         console.error("xAxis is not initialized.");

//       }

//     }



//     // Draw the position line

//     // drawPositionLine(clickedPosition);

//   } else {

//     console.log("Clearing orange bullets");

//     orangeBullets.forEach((bullet) => bullet.dispose());

//     orangeBullets = [];

//   }

// };





// let positionLines = [];



// const drawPositionLine = (clickedPosition) => {

//   if (!clickedPosition) {

//     console.warn("No clicked position provided.");

//     return;

//   }



//   const valueSeries = valueSeriesRef.current;

//   if (!valueSeries) {

//     console.error("Value series is not initialized.");

//     return;

//   }



//   // Clear existing lines

//   positionLines.forEach((line) => line.dispose());

//   positionLines = [];



//   const { openedAt, closedAt, direction } = clickedPosition;



//   const openingDate = new Date(openedAt).getTime();

//   const closingDate = new Date(closedAt).getTime();



//   const data = valueSeries.data.values;



//   // Helper function to find the closest candle

//   const findClosestCandle = (targetTime) => {

//     return data.reduce((closest, candle) => {

//       const candleTime = candle.Date;

//       if (

//         !closest ||

//         Math.abs(targetTime - candleTime) < Math.abs(targetTime - closest.Date)

//       ) {

//         return candle;

//       }

//       return closest;

//     }, null);

//   };



//   // Get the opening and closing candles

//   const openingCandle = findClosestCandle(openingDate);

//   const closingCandle = findClosestCandle(closingDate);



//   if (!openingCandle || !closingCandle) {

//     console.warn("Opening or closing candle not found.");

//     return;

//   }



//   const xAxis = valueSeries.get("xAxis");

//   const yAxis = valueSeries.get("yAxis");



//   if (!xAxis || !yAxis) {

//     console.error("Axes are not initialized.");

//     return;

//   }



//   const root = valueSeries._root;



//   // Calculate line coordinates

//   const startX = xAxis.valueToPosition(openingCandle.Date) * root.container.width();

//   const startY = yAxis.valueToPosition(openingCandle.Close) * root.container.height();

//   const endX = xAxis.valueToPosition(closingCandle.Date) * root.container.width();

//   const endY = yAxis.valueToPosition(closingCandle.Close) * root.container.height();



//   if (isNaN(startX) || isNaN(startY) || isNaN(endX) || isNaN(endY)) {

//     console.error("Invalid line coordinates.");

//     return;

//   }



//   console.log("Start X, Y:", startX, startY);

//   console.log("End X, Y:", endX, endY);



//   // Draw the line

//   const line = am5.Graphics.new(root, {

//     stroke: am5.color(direction === "Buy" ? "rgb(17, 209, 97)" : "rgb(245, 36, 36)"),

//     strokeWidth: 2,

//     strokeDasharray: [3, 3],

//     layer: 100,

//   });



//   line.set("draw", (display) => {

//     display.moveTo(startX, startY);

//     display.lineTo(endX, endY);

//   });



//   valueSeries.bulletsContainer.children.push(line);

//   positionLines.push(line);



//   console.log("Line drawn successfully!");

// };













  // useEffect(() => {

  //   return () => {

  //     chartRef.current && chartRef.current.dispose();

  //   };

  // }, []);

function formatNumber(num, max_limit = 8) {

    let numStr = num.toString();



    if (numStr.length <= max_limit) {

       return num;

    }



    let [integerPart, decimalPart] = numStr.split(".");



    if (integerPart.length >= max_limit) {

        return parseFloat(integerPart);

    }



    let allowedDecimals = max_limit - integerPart.length - 1;

    let truncatedDecimal = decimalPart.substring(0, allowedDecimals);



    let formattedNum = `${integerPart}.${truncatedDecimal}`;



    return parseFloat(formattedNum);

}



  // update price chart with live feeds

  const updateLiveFeedData = () => {

    const tick = platFromData[1];

    const stock = chartRef.current;

    const series = valueSeriesRef.current;

    if (!matchesChartSubscription(tick, chartSubscription)

        || loadedChartRequestKeyRef.current !== chartRequestKey

        || !stock || stock.isDisposed() || !series || series.isDisposed()

        || stock.get('stockSeries') !== series) return;

    const last = series.data.getIndex(series.data.length - 1);

    const row = mergeLiveCandle(last, tick, getChartIntervalMs(selectedTimeFrame));

    if (!row || !liveTickIdentityRef.current(series, tick)) return;

    const volume = volumeFor(series);

    if (!last || row.Date > last.Date) {

      volume?.data.push(row);

      series.data.push(row);

      currentChartDataRef.current.push(row);

    } else if (!sameCandle(last, row)) {

      const index = series.data.length - 1;

      // Keep OHLC and volume in the same order before indicator validation.

      volume?.data.setIndex(index, row);

      series.data.setIndex(index, row);

      currentChartDataRef.current[index] = row;

    }

    if (currentLabel2Ref.current && !currentLabel2Ref.current.isDisposed()) {

      currentValueDataItem2Ref.current?.set('value', row.Close);

      currentLabel2Ref.current.set('text', row.Close);

      currentLabel2Ref.current.get('background')?.setAll({ fill: am5.color(selectedStyle.sellColor), fillOpacity: 1 });

    }

    const ask = Number.parseFloat(tick.ask);

    if (Number.isFinite(ask) && currentLabelNew2Ref.current && !currentLabelNew2Ref.current.isDisposed()) {

      currentValueDataItemNewRef.current?.set('value', ask);

      currentLabelNew2Ref.current.set('text', ask);

      currentLabelNew2Ref.current.get('background')?.setAll({ fill: am5.color(selectedStyle.buyColor), fillOpacity: 1 });

    }

  };



  return (

    <div className="Chart global-platfrom">

      <div id="chartcontrols"></div>

      <div id="chartdiv"></div>



      {(loadingSymbolContext || chartLoading) && (

        <div className="chart-loading-overlay"><Spinner /></div>

      )}

    </div>

  );

};



// Sidebar/layout state does not change chart props; context updates still render.

export default React.memo(Chart);

